/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as DonateRouteRouteImport } from "./routes/donate/route"
import { Route as DonateIndexRouteImport } from "./routes/donate/index"
import { Route as AdminIndexRouteImport } from "./routes/admin/index"
import { Route as UserIndexRouteImport } from "./routes/_user/index"
import { Route as DonateScrapRouteImport } from "./routes/donate/scrap"
import { Route as DonateItemsRouteImport } from "./routes/donate/items"
import { Route as DonateInkindRouteImport } from "./routes/donate/inkind"
import { Route as DonateGeneralRouteImport } from "./routes/donate/general"
import { Route as UserSignupRouteImport } from "./routes/_user/signup"
import { Route as UserLoginRouteImport } from "./routes/_user/login"
import { Route as UserCsrPartnershipRouteImport } from "./routes/_user/csr-partnership"
import { Route as UserContactRouteImport } from "./routes/_user/contact"
import { Route as UserAccountRouteImport } from "./routes/_user/account"
import { Route as UserAboutRouteImport } from "./routes/_user/about"
import { Route as DonateThankYouRefRouteImport } from "./routes/donate/thank-you.$ref"
import { Route as AdminTiffinSevaDonationsRouteImport } from "./routes/admin/tiffin-seva/donations"
import { Route as AdminTiffinSevaDashboardRouteImport } from "./routes/admin/tiffin-seva/dashboard"
import { Route as AdminTiffinSevaApplicationsRouteImport } from "./routes/admin/tiffin-seva/applications"
import { Route as AdminWebsiteTrusteesRouteImport } from "./routes/admin/_website/trustees"
import { Route as AdminWebsitePostsRouteImport } from "./routes/admin/_website/posts"
import { Route as AdminWebsiteGalleryRouteImport } from "./routes/admin/_website/gallery"
import { Route as AdminUserRolesUserPermissionsRouteImport } from "./routes/admin/_user-roles/user-permissions"
import { Route as AdminSystemStaffRolesRouteImport } from "./routes/admin/_system/staff-roles"
import { Route as AdminResidentsVisitorsRouteImport } from "./routes/admin/_residents/visitors"
import { Route as AdminResidentsVisitorInquiryRouteImport } from "./routes/admin/_residents/visitor-inquiry"
import { Route as AdminResidentsResidentsRouteImport } from "./routes/admin/_residents/residents"
import { Route as AdminResidentsResidentRegistrationRouteImport } from "./routes/admin/_residents/resident-registration"
import { Route as AdminResidentsResidentFamilyRouteImport } from "./routes/admin/_residents/resident-family"
import { Route as AdminResidentsResidentDeathRouteImport } from "./routes/admin/_residents/resident-death"
import { Route as AdminResidentsAdoptionRouteImport } from "./routes/admin/_residents/adoption"
import { Route as AdminOverviewReportsRouteImport } from "./routes/admin/_overview/reports"
import { Route as AdminOverviewDashboardRouteImport } from "./routes/admin/_overview/dashboard"
import { Route as AdminOverviewAiStudioRouteImport } from "./routes/admin/_overview/ai-studio"
import { Route as AdminModulesInventoryRouteImport } from "./routes/admin/_modules/inventory"
import { Route as AdminModulesHrPayrollRouteImport } from "./routes/admin/_modules/hr-payroll"
import { Route as AdminModulesEventCategoriesRouteImport } from "./routes/admin/_modules/event-categories"
import { Route as AdminModulesCommunityEventsRouteImport } from "./routes/admin/_modules/community-events"
import { Route as AdminModulesCommunicationRouteImport } from "./routes/admin/_modules/communication"
import { Route as AdminManualReceiptManualReceiptsRouteImport } from "./routes/admin/_manual-receipt/manual-receipts"
import { Route as AdminListMasterTreatmentMasterRouteImport } from "./routes/admin/_list-master/treatment-master"
import { Route as AdminListMasterRelationshipsRouteImport } from "./routes/admin/_list-master/relationships"
import { Route as AdminListMasterJainPanchangRouteImport } from "./routes/admin/_list-master/jain-panchang"
import { Route as AdminListMasterFestivalsRouteImport } from "./routes/admin/_list-master/festivals"
import { Route as AdminListMasterDistrictsRouteImport } from "./routes/admin/_list-master/districts"
import { Route as AdminListMasterCitiesRouteImport } from "./routes/admin/_list-master/cities"
import { Route as AdminListMasterAreasRouteImport } from "./routes/admin/_list-master/areas"
import { Route as AdminGaushalaVrindavanGaushalaRouteImport } from "./routes/admin/_gaushala/vrindavan-gaushala"
import { Route as AdminGaushalaGaushalaSchemesRouteImport } from "./routes/admin/_gaushala/gaushala-schemes"
import { Route as AdminGaushalaGaushalaDonationsRouteImport } from "./routes/admin/_gaushala/gaushala-donations"
import { Route as AdminEngagementTiffinRouteImport } from "./routes/admin/_engagement/tiffin"
import { Route as AdminEngagementPunyaTithiRouteImport } from "./routes/admin/_engagement/punya-tithi"
import { Route as AdminEngagementInquiriesRouteImport } from "./routes/admin/_engagement/inquiries"
import { Route as AdminEngagementFeedbackRouteImport } from "./routes/admin/_engagement/feedback"
import { Route as AdminEngagementCsrInquiriesRouteImport } from "./routes/admin/_engagement/csr-inquiries"
import { Route as AdminDonationsScrapDonationsRouteImport } from "./routes/admin/_donations/scrap-donations"
import { Route as AdminDonationsRecurringRouteImport } from "./routes/admin/_donations/recurring"
import { Route as AdminDonationsReceiptsRouteImport } from "./routes/admin/_donations/receipts"
import { Route as AdminDonationsMedicalRouteImport } from "./routes/admin/_donations/medical"
import { Route as AdminDonationsDonorsRouteImport } from "./routes/admin/_donations/donors"
import { Route as AdminDonationsDonationsRouteImport } from "./routes/admin/_donations/donations"
import { Route as AdminDonationSetupSevaRouteImport } from "./routes/admin/_donation-setup/seva"
import { Route as AdminDonationSetupPaymentSettingsRouteImport } from "./routes/admin/_donation-setup/payment-settings"
import { Route as AdminDonationSetupItemCategoriesRouteImport } from "./routes/admin/_donation-setup/item-categories"
import { Route as AdminDonationSetupInkindRouteImport } from "./routes/admin/_donation-setup/inkind"
import { Route as AdminDonationSetupInfrastructureRouteImport } from "./routes/admin/_donation-setup/infrastructure"
import { Route as AdminDonationSetupEventsRouteImport } from "./routes/admin/_donation-setup/events"
import { Route as AdminDonationSetupDonationMastersRouteImport } from "./routes/admin/_donation-setup/donation-masters"
import { Route as AdminDonationSetupCampaignsRouteImport } from "./routes/admin/_donation-setup/campaigns"
import { Route as AdminBhojanshalaBhojanSchemesRouteImport } from "./routes/admin/_bhojanshala/bhojan-schemes"
import { Route as AdminBhojanshalaBhojanPackagesRouteImport } from "./routes/admin/_bhojanshala/bhojan-packages"
import { Route as AdminBhojanshalaBhojanDonationsRouteImport } from "./routes/admin/_bhojanshala/bhojan-donations"
import { Route as AdminBhojanshalaBhojanCategoriesRouteImport } from "./routes/admin/_bhojanshala/bhojan-categories"
import { Route as AdminAdmissionsFamilyDetailsRouteImport } from "./routes/admin/_admissions/family-details"
import { Route as AdminAdmissionsElderRegistrationRouteImport } from "./routes/admin/_admissions/elder-registration"
import { Route as AdminAdmissionsAdmissionRecommendationRouteImport } from "./routes/admin/_admissions/admission-recommendation"
import { Route as AdminAdmissionsAdmissionInquiryRouteImport } from "./routes/admin/_admissions/admission-inquiry"
import { Route as AdminAdmissionsAdmissionApprovalRouteImport } from "./routes/admin/_admissions/admission-approval"
import { Route as AdminAdmissionsAdmissionApplicationsRouteImport } from "./routes/admin/_admissions/admission-applications"
import { Route as UserTrustTrusteesRouteImport } from "./routes/_user/_trust/trustees"
import { Route as UserTrustTransparencyRouteImport } from "./routes/_user/_trust/transparency"
import { Route as UserProgramsTiffinSevaRouteImport } from "./routes/_user/_programs/tiffin-seva"
import { Route as UserProgramsGruhUdhyogRouteImport } from "./routes/_user/_programs/gruh-udhyog"
import { Route as UserProgramsGaushalaRouteImport } from "./routes/_user/_programs/gaushala"
import { Route as UserProgramsBhojanshalaRouteImport } from "./routes/_user/_programs/bhojanshala"
import { Route as UserCommunityVisitorInquiryRouteImport } from "./routes/_user/_community/visitor-inquiry"
import { Route as UserCommunityVisitorFormRouteImport } from "./routes/_user/_community/visitor-form"
import { Route as UserCommunityNewsRouteImport } from "./routes/_user/_community/news"
import { Route as UserCommunityJainPanchangRouteImport } from "./routes/_user/_community/jain-panchang"
import { Route as UserCommunityGalleryRouteImport } from "./routes/_user/_community/gallery"
import { Route as UserCommunityFeedbackRouteImport } from "./routes/_user/_community/feedback"
import { Route as UserCommunityEventsRouteImport } from "./routes/_user/_community/events"
import { Route as UserCareResidentCareRouteImport } from "./routes/_user/_care/resident-care"
import { Route as UserCareHealthcareRouteImport } from "./routes/_user/_care/healthcare"
import { Route as UserCareElderCareProgramRouteImport } from "./routes/_user/_care/elder-care-program"
import { Route as UserAdmissionApplyAdmissionRouteImport } from "./routes/_user/_admission/apply-admission"
import { Route as UserAdmissionAdmissionInquiryRouteImport } from "./routes/_user/_admission/admission-inquiry"
import { Route as UserCareHealthcareIndexRouteImport } from "./routes/_user/_care/healthcare.index"
import { Route as DonateCKindIdRouteImport } from "./routes/donate/c.$kind.$id"
import { Route as AdminModulesHealthcareMedicalStaffRouteImport } from "./routes/admin/_modules/_healthcare/medical-staff"
import { Route as AdminModulesHealthcareHospitalProfileRouteImport } from "./routes/admin/_modules/_healthcare/hospital-profile"
import { Route as AdminModulesHealthcareHealthcareManagementRouteImport } from "./routes/admin/_modules/_healthcare/healthcare-management"
import { Route as AdminModulesHealthcareHealthcareDonationsRouteImport } from "./routes/admin/_modules/_healthcare/healthcare-donations"
import { Route as AdminModulesHealthcareHealthcareRouteImport } from "./routes/admin/_modules/_healthcare/healthcare"
import { Route as AdminModulesGruhUdhyogStockEntriesRouteImport } from "./routes/admin/_modules/_gruh-udhyog/stock-entries"
import { Route as AdminModulesGruhUdhyogProductsRouteImport } from "./routes/admin/_modules/_gruh-udhyog/products"
import { Route as AdminModulesGruhUdhyogProductVariantsRouteImport } from "./routes/admin/_modules/_gruh-udhyog/product-variants"
import { Route as AdminModulesGruhUdhyogProductOrdersRouteImport } from "./routes/admin/_modules/_gruh-udhyog/product-orders"
import { Route as AdminModulesGruhUdhyogProductCategoriesRouteImport } from "./routes/admin/_modules/_gruh-udhyog/product-categories"
import { Route as AdminModulesGruhUdhyogGruhUdhyogInventoryRouteImport } from "./routes/admin/_modules/_gruh-udhyog/gruh-udhyog-inventory"
import { Route as AdminModulesGruhUdhyogGruhUdhyogRouteImport } from "./routes/admin/_modules/_gruh-udhyog/gruh-udhyog"
import { Route as AdminModulesGruhUdhyogFranchiseEnquiriesRouteImport } from "./routes/admin/_modules/_gruh-udhyog/franchise-enquiries"
import { Route as AdminModulesGaushalaGaushalaRouteImport } from "./routes/admin/_modules/_gaushala/gaushala"
import { Route as AdminModulesGaushalaAnimalsRouteImport } from "./routes/admin/_modules/_gaushala/animals"
import { Route as AdminModulesElderCareResidentsRouteImport } from "./routes/admin/_modules/_elder-care/residents"
import { Route as AdminModulesElderCareElderCareRouteImport } from "./routes/admin/_modules/_elder-care/elder-care"
import { Route as AdminAdmissionsAdmissionApplicationsIdRouteImport } from "./routes/admin/_admissions/admission-applications.$id"
import { Route as UserCareHealthcareIdRouteImport } from "./routes/_user/_care/healthcare.$id"
import { Route as AdminModulesElderCareResidentsIdRouteImport } from "./routes/admin/_modules/_elder-care/residents.$id"
import { Route as AdminModulesGruhUdhyogInventoryRouteImport } from "./routes/admin/_modules/_gruh-udhyog/inventory."

const DonateRouteRoute = DonateRouteRouteImport.update({
  id: "/donate",
  path: "/donate",
  getParentRoute: () => rootRouteImport,
} as any)
const DonateIndexRoute = DonateIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DonateRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/admin/",
  path: "/admin/",
  getParentRoute: () => rootRouteImport,
} as any)
const UserIndexRoute = UserIndexRouteImport.update({
  id: "/_user/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const DonateScrapRoute = DonateScrapRouteImport.update({
  id: "/scrap",
  path: "/scrap",
  getParentRoute: () => DonateRouteRoute,
} as any)
const DonateItemsRoute = DonateItemsRouteImport.update({
  id: "/items",
  path: "/items",
  getParentRoute: () => DonateRouteRoute,
} as any)
const DonateInkindRoute = DonateInkindRouteImport.update({
  id: "/inkind",
  path: "/inkind",
  getParentRoute: () => DonateRouteRoute,
} as any)
const DonateGeneralRoute = DonateGeneralRouteImport.update({
  id: "/general",
  path: "/general",
  getParentRoute: () => DonateRouteRoute,
} as any)
const UserSignupRoute = UserSignupRouteImport.update({
  id: "/_user/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const UserLoginRoute = UserLoginRouteImport.update({
  id: "/_user/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCsrPartnershipRoute = UserCsrPartnershipRouteImport.update({
  id: "/_user/csr-partnership",
  path: "/csr-partnership",
  getParentRoute: () => rootRouteImport,
} as any)
const UserContactRoute = UserContactRouteImport.update({
  id: "/_user/contact",
  path: "/contact",
  getParentRoute: () => rootRouteImport,
} as any)
const UserAccountRoute = UserAccountRouteImport.update({
  id: "/_user/account",
  path: "/account",
  getParentRoute: () => rootRouteImport,
} as any)
const UserAboutRoute = UserAboutRouteImport.update({
  id: "/_user/about",
  path: "/about",
  getParentRoute: () => rootRouteImport,
} as any)
const DonateThankYouRefRoute = DonateThankYouRefRouteImport.update({
  id: "/thank-you/$ref",
  path: "/thank-you/$ref",
  getParentRoute: () => DonateRouteRoute,
} as any)
const AdminTiffinSevaDonationsRoute =
  AdminTiffinSevaDonationsRouteImport.update({
    id: "/admin/tiffin-seva/donations",
    path: "/admin/tiffin-seva/donations",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminTiffinSevaDashboardRoute =
  AdminTiffinSevaDashboardRouteImport.update({
    id: "/admin/tiffin-seva/dashboard",
    path: "/admin/tiffin-seva/dashboard",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminTiffinSevaApplicationsRoute =
  AdminTiffinSevaApplicationsRouteImport.update({
    id: "/admin/tiffin-seva/applications",
    path: "/admin/tiffin-seva/applications",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminWebsiteTrusteesRoute = AdminWebsiteTrusteesRouteImport.update({
  id: "/admin/_website/trustees",
  path: "/admin/trustees",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWebsitePostsRoute = AdminWebsitePostsRouteImport.update({
  id: "/admin/_website/posts",
  path: "/admin/posts",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWebsiteGalleryRoute = AdminWebsiteGalleryRouteImport.update({
  id: "/admin/_website/gallery",
  path: "/admin/gallery",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUserRolesUserPermissionsRoute =
  AdminUserRolesUserPermissionsRouteImport.update({
    id: "/admin/_user-roles/user-permissions",
    path: "/admin/user-permissions",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSystemStaffRolesRoute = AdminSystemStaffRolesRouteImport.update({
  id: "/admin/_system/staff-roles",
  path: "/admin/staff-roles",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminResidentsVisitorsRoute = AdminResidentsVisitorsRouteImport.update({
  id: "/admin/_residents/visitors",
  path: "/admin/visitors",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminResidentsVisitorInquiryRoute =
  AdminResidentsVisitorInquiryRouteImport.update({
    id: "/admin/_residents/visitor-inquiry",
    path: "/admin/visitor-inquiry",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminResidentsResidentsRoute = AdminResidentsResidentsRouteImport.update({
  id: "/admin/_residents/residents",
  path: "/admin/residents",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminResidentsResidentRegistrationRoute =
  AdminResidentsResidentRegistrationRouteImport.update({
    id: "/admin/_residents/resident-registration",
    path: "/admin/resident-registration",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminResidentsResidentFamilyRoute =
  AdminResidentsResidentFamilyRouteImport.update({
    id: "/admin/_residents/resident-family",
    path: "/admin/resident-family",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminResidentsResidentDeathRoute =
  AdminResidentsResidentDeathRouteImport.update({
    id: "/admin/_residents/resident-death",
    path: "/admin/resident-death",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminResidentsAdoptionRoute = AdminResidentsAdoptionRouteImport.update({
  id: "/admin/_residents/adoption",
  path: "/admin/adoption",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOverviewReportsRoute = AdminOverviewReportsRouteImport.update({
  id: "/admin/_overview/reports",
  path: "/admin/reports",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOverviewDashboardRoute = AdminOverviewDashboardRouteImport.update({
  id: "/admin/_overview/dashboard",
  path: "/admin/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOverviewAiStudioRoute = AdminOverviewAiStudioRouteImport.update({
  id: "/admin/_overview/ai-studio",
  path: "/admin/ai-studio",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModulesInventoryRoute = AdminModulesInventoryRouteImport.update({
  id: "/admin/_modules/inventory",
  path: "/admin/inventory",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModulesHrPayrollRoute = AdminModulesHrPayrollRouteImport.update({
  id: "/admin/_modules/hr-payroll",
  path: "/admin/hr-payroll",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModulesEventCategoriesRoute =
  AdminModulesEventCategoriesRouteImport.update({
    id: "/admin/_modules/event-categories",
    path: "/admin/event-categories",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesCommunityEventsRoute =
  AdminModulesCommunityEventsRouteImport.update({
    id: "/admin/_modules/community-events",
    path: "/admin/community-events",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesCommunicationRoute =
  AdminModulesCommunicationRouteImport.update({
    id: "/admin/_modules/communication",
    path: "/admin/communication",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminManualReceiptManualReceiptsRoute =
  AdminManualReceiptManualReceiptsRouteImport.update({
    id: "/admin/_manual-receipt/manual-receipts",
    path: "/admin/manual-receipts",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminListMasterTreatmentMasterRoute =
  AdminListMasterTreatmentMasterRouteImport.update({
    id: "/admin/_list-master/treatment-master",
    path: "/admin/treatment-master",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminListMasterRelationshipsRoute =
  AdminListMasterRelationshipsRouteImport.update({
    id: "/admin/_list-master/relationships",
    path: "/admin/relationships",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminListMasterJainPanchangRoute =
  AdminListMasterJainPanchangRouteImport.update({
    id: "/admin/_list-master/jain-panchang",
    path: "/admin/jain-panchang",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminListMasterFestivalsRoute =
  AdminListMasterFestivalsRouteImport.update({
    id: "/admin/_list-master/festivals",
    path: "/admin/festivals",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminListMasterDistrictsRoute =
  AdminListMasterDistrictsRouteImport.update({
    id: "/admin/_list-master/districts",
    path: "/admin/districts",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminListMasterCitiesRoute = AdminListMasterCitiesRouteImport.update({
  id: "/admin/_list-master/cities",
  path: "/admin/cities",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminListMasterAreasRoute = AdminListMasterAreasRouteImport.update({
  id: "/admin/_list-master/areas",
  path: "/admin/areas",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGaushalaVrindavanGaushalaRoute =
  AdminGaushalaVrindavanGaushalaRouteImport.update({
    id: "/admin/_gaushala/vrindavan-gaushala",
    path: "/admin/vrindavan-gaushala",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminGaushalaGaushalaSchemesRoute =
  AdminGaushalaGaushalaSchemesRouteImport.update({
    id: "/admin/_gaushala/gaushala-schemes",
    path: "/admin/gaushala-schemes",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminGaushalaGaushalaDonationsRoute =
  AdminGaushalaGaushalaDonationsRouteImport.update({
    id: "/admin/_gaushala/gaushala-donations",
    path: "/admin/gaushala-donations",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminEngagementTiffinRoute = AdminEngagementTiffinRouteImport.update({
  id: "/admin/_engagement/tiffin",
  path: "/admin/tiffin",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEngagementPunyaTithiRoute =
  AdminEngagementPunyaTithiRouteImport.update({
    id: "/admin/_engagement/punya-tithi",
    path: "/admin/punya-tithi",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminEngagementInquiriesRoute =
  AdminEngagementInquiriesRouteImport.update({
    id: "/admin/_engagement/inquiries",
    path: "/admin/inquiries",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminEngagementFeedbackRoute = AdminEngagementFeedbackRouteImport.update({
  id: "/admin/_engagement/feedback",
  path: "/admin/feedback",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEngagementCsrInquiriesRoute =
  AdminEngagementCsrInquiriesRouteImport.update({
    id: "/admin/_engagement/csr-inquiries",
    path: "/admin/csr-inquiries",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationsScrapDonationsRoute =
  AdminDonationsScrapDonationsRouteImport.update({
    id: "/admin/_donations/scrap-donations",
    path: "/admin/scrap-donations",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationsRecurringRoute = AdminDonationsRecurringRouteImport.update({
  id: "/admin/_donations/recurring",
  path: "/admin/recurring",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDonationsReceiptsRoute = AdminDonationsReceiptsRouteImport.update({
  id: "/admin/_donations/receipts",
  path: "/admin/receipts",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDonationsMedicalRoute = AdminDonationsMedicalRouteImport.update({
  id: "/admin/_donations/medical",
  path: "/admin/medical",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDonationsDonorsRoute = AdminDonationsDonorsRouteImport.update({
  id: "/admin/_donations/donors",
  path: "/admin/donors",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDonationsDonationsRoute = AdminDonationsDonationsRouteImport.update({
  id: "/admin/_donations/donations",
  path: "/admin/donations",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDonationSetupSevaRoute = AdminDonationSetupSevaRouteImport.update({
  id: "/admin/_donation-setup/seva",
  path: "/admin/seva",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDonationSetupPaymentSettingsRoute =
  AdminDonationSetupPaymentSettingsRouteImport.update({
    id: "/admin/_donation-setup/payment-settings",
    path: "/admin/payment-settings",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationSetupItemCategoriesRoute =
  AdminDonationSetupItemCategoriesRouteImport.update({
    id: "/admin/_donation-setup/item-categories",
    path: "/admin/item-categories",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationSetupInkindRoute =
  AdminDonationSetupInkindRouteImport.update({
    id: "/admin/_donation-setup/inkind",
    path: "/admin/inkind",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationSetupInfrastructureRoute =
  AdminDonationSetupInfrastructureRouteImport.update({
    id: "/admin/_donation-setup/infrastructure",
    path: "/admin/infrastructure",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationSetupEventsRoute =
  AdminDonationSetupEventsRouteImport.update({
    id: "/admin/_donation-setup/events",
    path: "/admin/events",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationSetupDonationMastersRoute =
  AdminDonationSetupDonationMastersRouteImport.update({
    id: "/admin/_donation-setup/donation-masters",
    path: "/admin/donation-masters",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDonationSetupCampaignsRoute =
  AdminDonationSetupCampaignsRouteImport.update({
    id: "/admin/_donation-setup/campaigns",
    path: "/admin/campaigns",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminBhojanshalaBhojanSchemesRoute =
  AdminBhojanshalaBhojanSchemesRouteImport.update({
    id: "/admin/_bhojanshala/bhojan-schemes",
    path: "/admin/bhojan-schemes",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminBhojanshalaBhojanPackagesRoute =
  AdminBhojanshalaBhojanPackagesRouteImport.update({
    id: "/admin/_bhojanshala/bhojan-packages",
    path: "/admin/bhojan-packages",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminBhojanshalaBhojanDonationsRoute =
  AdminBhojanshalaBhojanDonationsRouteImport.update({
    id: "/admin/_bhojanshala/bhojan-donations",
    path: "/admin/bhojan-donations",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminBhojanshalaBhojanCategoriesRoute =
  AdminBhojanshalaBhojanCategoriesRouteImport.update({
    id: "/admin/_bhojanshala/bhojan-categories",
    path: "/admin/bhojan-categories",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdmissionsFamilyDetailsRoute =
  AdminAdmissionsFamilyDetailsRouteImport.update({
    id: "/admin/_admissions/family-details",
    path: "/admin/family-details",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdmissionsElderRegistrationRoute =
  AdminAdmissionsElderRegistrationRouteImport.update({
    id: "/admin/_admissions/elder-registration",
    path: "/admin/elder-registration",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdmissionsAdmissionRecommendationRoute =
  AdminAdmissionsAdmissionRecommendationRouteImport.update({
    id: "/admin/_admissions/admission-recommendation",
    path: "/admin/admission-recommendation",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdmissionsAdmissionInquiryRoute =
  AdminAdmissionsAdmissionInquiryRouteImport.update({
    id: "/admin/_admissions/admission-inquiry",
    path: "/admin/admission-inquiry",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdmissionsAdmissionApprovalRoute =
  AdminAdmissionsAdmissionApprovalRouteImport.update({
    id: "/admin/_admissions/admission-approval",
    path: "/admin/admission-approval",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdmissionsAdmissionApplicationsRoute =
  AdminAdmissionsAdmissionApplicationsRouteImport.update({
    id: "/admin/_admissions/admission-applications",
    path: "/admin/admission-applications",
    getParentRoute: () => rootRouteImport,
  } as any)
const UserTrustTrusteesRoute = UserTrustTrusteesRouteImport.update({
  id: "/_user/_trust/trustees",
  path: "/trustees",
  getParentRoute: () => rootRouteImport,
} as any)
const UserTrustTransparencyRoute = UserTrustTransparencyRouteImport.update({
  id: "/_user/_trust/transparency",
  path: "/transparency",
  getParentRoute: () => rootRouteImport,
} as any)
const UserProgramsTiffinSevaRoute = UserProgramsTiffinSevaRouteImport.update({
  id: "/_user/_programs/tiffin-seva",
  path: "/tiffin-seva",
  getParentRoute: () => rootRouteImport,
} as any)
const UserProgramsGruhUdhyogRoute = UserProgramsGruhUdhyogRouteImport.update({
  id: "/_user/_programs/gruh-udhyog",
  path: "/gruh-udhyog",
  getParentRoute: () => rootRouteImport,
} as any)
const UserProgramsGaushalaRoute = UserProgramsGaushalaRouteImport.update({
  id: "/_user/_programs/gaushala",
  path: "/gaushala",
  getParentRoute: () => rootRouteImport,
} as any)
const UserProgramsBhojanshalaRoute = UserProgramsBhojanshalaRouteImport.update({
  id: "/_user/_programs/bhojanshala",
  path: "/bhojanshala",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCommunityVisitorInquiryRoute =
  UserCommunityVisitorInquiryRouteImport.update({
    id: "/_user/_community/visitor-inquiry",
    path: "/visitor-inquiry",
    getParentRoute: () => rootRouteImport,
  } as any)
const UserCommunityVisitorFormRoute =
  UserCommunityVisitorFormRouteImport.update({
    id: "/_user/_community/visitor-form",
    path: "/visitor-form",
    getParentRoute: () => rootRouteImport,
  } as any)
const UserCommunityNewsRoute = UserCommunityNewsRouteImport.update({
  id: "/_user/_community/news",
  path: "/news",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCommunityJainPanchangRoute =
  UserCommunityJainPanchangRouteImport.update({
    id: "/_user/_community/jain-panchang",
    path: "/jain-panchang",
    getParentRoute: () => rootRouteImport,
  } as any)
const UserCommunityGalleryRoute = UserCommunityGalleryRouteImport.update({
  id: "/_user/_community/gallery",
  path: "/gallery",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCommunityFeedbackRoute = UserCommunityFeedbackRouteImport.update({
  id: "/_user/_community/feedback",
  path: "/feedback",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCommunityEventsRoute = UserCommunityEventsRouteImport.update({
  id: "/_user/_community/events",
  path: "/events",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCareResidentCareRoute = UserCareResidentCareRouteImport.update({
  id: "/_user/_care/resident-care",
  path: "/resident-care",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCareHealthcareRoute = UserCareHealthcareRouteImport.update({
  id: "/_user/_care/healthcare",
  path: "/healthcare",
  getParentRoute: () => rootRouteImport,
} as any)
const UserCareElderCareProgramRoute =
  UserCareElderCareProgramRouteImport.update({
    id: "/_user/_care/elder-care-program",
    path: "/elder-care-program",
    getParentRoute: () => rootRouteImport,
  } as any)
const UserAdmissionApplyAdmissionRoute =
  UserAdmissionApplyAdmissionRouteImport.update({
    id: "/_user/_admission/apply-admission",
    path: "/apply-admission",
    getParentRoute: () => rootRouteImport,
  } as any)
const UserAdmissionAdmissionInquiryRoute =
  UserAdmissionAdmissionInquiryRouteImport.update({
    id: "/_user/_admission/admission-inquiry",
    path: "/admission-inquiry",
    getParentRoute: () => rootRouteImport,
  } as any)
const UserCareHealthcareIndexRoute = UserCareHealthcareIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => UserCareHealthcareRoute,
} as any)
const DonateCKindIdRoute = DonateCKindIdRouteImport.update({
  id: "/c/$kind/$id",
  path: "/c/$kind/$id",
  getParentRoute: () => DonateRouteRoute,
} as any)
const AdminModulesHealthcareMedicalStaffRoute =
  AdminModulesHealthcareMedicalStaffRouteImport.update({
    id: "/admin/_modules/_healthcare/medical-staff",
    path: "/admin/medical-staff",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesHealthcareHospitalProfileRoute =
  AdminModulesHealthcareHospitalProfileRouteImport.update({
    id: "/admin/_modules/_healthcare/hospital-profile",
    path: "/admin/hospital-profile",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesHealthcareHealthcareManagementRoute =
  AdminModulesHealthcareHealthcareManagementRouteImport.update({
    id: "/admin/_modules/_healthcare/healthcare-management",
    path: "/admin/healthcare-management",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesHealthcareHealthcareDonationsRoute =
  AdminModulesHealthcareHealthcareDonationsRouteImport.update({
    id: "/admin/_modules/_healthcare/healthcare-donations",
    path: "/admin/healthcare-donations",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesHealthcareHealthcareRoute =
  AdminModulesHealthcareHealthcareRouteImport.update({
    id: "/admin/_modules/_healthcare/healthcare",
    path: "/admin/healthcare",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogStockEntriesRoute =
  AdminModulesGruhUdhyogStockEntriesRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/stock-entries",
    path: "/admin/stock-entries",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogProductsRoute =
  AdminModulesGruhUdhyogProductsRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/products",
    path: "/admin/products",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogProductVariantsRoute =
  AdminModulesGruhUdhyogProductVariantsRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/product-variants",
    path: "/admin/product-variants",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogProductOrdersRoute =
  AdminModulesGruhUdhyogProductOrdersRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/product-orders",
    path: "/admin/product-orders",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogProductCategoriesRoute =
  AdminModulesGruhUdhyogProductCategoriesRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/product-categories",
    path: "/admin/product-categories",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogGruhUdhyogInventoryRoute =
  AdminModulesGruhUdhyogGruhUdhyogInventoryRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/gruh-udhyog-inventory",
    path: "/admin/gruh-udhyog-inventory",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogGruhUdhyogRoute =
  AdminModulesGruhUdhyogGruhUdhyogRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/gruh-udhyog",
    path: "/admin/gruh-udhyog",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGruhUdhyogFranchiseEnquiriesRoute =
  AdminModulesGruhUdhyogFranchiseEnquiriesRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/franchise-enquiries",
    path: "/admin/franchise-enquiries",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGaushalaGaushalaRoute =
  AdminModulesGaushalaGaushalaRouteImport.update({
    id: "/admin/_modules/_gaushala/gaushala",
    path: "/admin/gaushala",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesGaushalaAnimalsRoute =
  AdminModulesGaushalaAnimalsRouteImport.update({
    id: "/admin/_modules/_gaushala/animals",
    path: "/admin/animals",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesElderCareResidentsRoute =
  AdminModulesElderCareResidentsRouteImport.update({
    id: "/admin/_modules/_elder-care/residents",
    path: "/admin/residents",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminModulesElderCareElderCareRoute =
  AdminModulesElderCareElderCareRouteImport.update({
    id: "/admin/_modules/_elder-care/elder-care",
    path: "/admin/elder-care",
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdmissionsAdmissionApplicationsIdRoute =
  AdminAdmissionsAdmissionApplicationsIdRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => AdminAdmissionsAdmissionApplicationsRoute,
  } as any)
const UserCareHealthcareIdRoute = UserCareHealthcareIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => UserCareHealthcareRoute,
} as any)
const AdminModulesElderCareResidentsIdRoute =
  AdminModulesElderCareResidentsIdRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => AdminModulesElderCareResidentsRoute,
  } as any)
const AdminModulesGruhUdhyogInventoryRoute =
  AdminModulesGruhUdhyogInventoryRouteImport.update({
    id: "/admin/_modules/_gruh-udhyog/inventory/",
    path: "/admin/inventory/",
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  "/donate": typeof DonateRouteRouteWithChildren
  "/about": typeof UserAboutRoute
  "/account": typeof UserAccountRoute
  "/contact": typeof UserContactRoute
  "/csr-partnership": typeof UserCsrPartnershipRoute
  "/login": typeof UserLoginRoute
  "/signup": typeof UserSignupRoute
  "/donate/general": typeof DonateGeneralRoute
  "/donate/inkind": typeof DonateInkindRoute
  "/donate/items": typeof DonateItemsRoute
  "/donate/scrap": typeof DonateScrapRoute
  "/": typeof UserIndexRoute
  "/admin/": typeof AdminIndexRoute
  "/donate/": typeof DonateIndexRoute
  "/admission-inquiry": typeof UserAdmissionAdmissionInquiryRoute
  "/apply-admission": typeof UserAdmissionApplyAdmissionRoute
  "/elder-care-program": typeof UserCareElderCareProgramRoute
  "/healthcare": typeof UserCareHealthcareRouteWithChildren
  "/resident-care": typeof UserCareResidentCareRoute
  "/events": typeof UserCommunityEventsRoute
  "/feedback": typeof UserCommunityFeedbackRoute
  "/gallery": typeof UserCommunityGalleryRoute
  "/jain-panchang": typeof UserCommunityJainPanchangRoute
  "/news": typeof UserCommunityNewsRoute
  "/visitor-form": typeof UserCommunityVisitorFormRoute
  "/visitor-inquiry": typeof UserCommunityVisitorInquiryRoute
  "/bhojanshala": typeof UserProgramsBhojanshalaRoute
  "/gaushala": typeof UserProgramsGaushalaRoute
  "/gruh-udhyog": typeof UserProgramsGruhUdhyogRoute
  "/tiffin-seva": typeof UserProgramsTiffinSevaRoute
  "/transparency": typeof UserTrustTransparencyRoute
  "/trustees": typeof UserTrustTrusteesRoute
  "/admin/admission-applications": typeof AdminAdmissionsAdmissionApplicationsRouteWithChildren
  "/admin/admission-approval": typeof AdminAdmissionsAdmissionApprovalRoute
  "/admin/admission-inquiry": typeof AdminAdmissionsAdmissionInquiryRoute
  "/admin/admission-recommendation": typeof AdminAdmissionsAdmissionRecommendationRoute
  "/admin/elder-registration": typeof AdminAdmissionsElderRegistrationRoute
  "/admin/family-details": typeof AdminAdmissionsFamilyDetailsRoute
  "/admin/bhojan-categories": typeof AdminBhojanshalaBhojanCategoriesRoute
  "/admin/bhojan-donations": typeof AdminBhojanshalaBhojanDonationsRoute
  "/admin/bhojan-packages": typeof AdminBhojanshalaBhojanPackagesRoute
  "/admin/bhojan-schemes": typeof AdminBhojanshalaBhojanSchemesRoute
  "/admin/campaigns": typeof AdminDonationSetupCampaignsRoute
  "/admin/donation-masters": typeof AdminDonationSetupDonationMastersRoute
  "/admin/events": typeof AdminDonationSetupEventsRoute
  "/admin/infrastructure": typeof AdminDonationSetupInfrastructureRoute
  "/admin/inkind": typeof AdminDonationSetupInkindRoute
  "/admin/item-categories": typeof AdminDonationSetupItemCategoriesRoute
  "/admin/payment-settings": typeof AdminDonationSetupPaymentSettingsRoute
  "/admin/seva": typeof AdminDonationSetupSevaRoute
  "/admin/donations": typeof AdminDonationsDonationsRoute
  "/admin/donors": typeof AdminDonationsDonorsRoute
  "/admin/medical": typeof AdminDonationsMedicalRoute
  "/admin/receipts": typeof AdminDonationsReceiptsRoute
  "/admin/recurring": typeof AdminDonationsRecurringRoute
  "/admin/scrap-donations": typeof AdminDonationsScrapDonationsRoute
  "/admin/csr-inquiries": typeof AdminEngagementCsrInquiriesRoute
  "/admin/feedback": typeof AdminEngagementFeedbackRoute
  "/admin/inquiries": typeof AdminEngagementInquiriesRoute
  "/admin/punya-tithi": typeof AdminEngagementPunyaTithiRoute
  "/admin/tiffin": typeof AdminEngagementTiffinRoute
  "/admin/gaushala-donations": typeof AdminGaushalaGaushalaDonationsRoute
  "/admin/gaushala-schemes": typeof AdminGaushalaGaushalaSchemesRoute
  "/admin/vrindavan-gaushala": typeof AdminGaushalaVrindavanGaushalaRoute
  "/admin/areas": typeof AdminListMasterAreasRoute
  "/admin/cities": typeof AdminListMasterCitiesRoute
  "/admin/districts": typeof AdminListMasterDistrictsRoute
  "/admin/festivals": typeof AdminListMasterFestivalsRoute
  "/admin/jain-panchang": typeof AdminListMasterJainPanchangRoute
  "/admin/relationships": typeof AdminListMasterRelationshipsRoute
  "/admin/treatment-master": typeof AdminListMasterTreatmentMasterRoute
  "/admin/manual-receipts": typeof AdminManualReceiptManualReceiptsRoute
  "/admin/communication": typeof AdminModulesCommunicationRoute
  "/admin/community-events": typeof AdminModulesCommunityEventsRoute
  "/admin/event-categories": typeof AdminModulesEventCategoriesRoute
  "/admin/hr-payroll": typeof AdminModulesHrPayrollRoute
  "/admin/inventory": typeof AdminModulesInventoryRoute
  "/admin/ai-studio": typeof AdminOverviewAiStudioRoute
  "/admin/dashboard": typeof AdminOverviewDashboardRoute
  "/admin/reports": typeof AdminOverviewReportsRoute
  "/admin/adoption": typeof AdminResidentsAdoptionRoute
  "/admin/resident-death": typeof AdminResidentsResidentDeathRoute
  "/admin/resident-family": typeof AdminResidentsResidentFamilyRoute
  "/admin/resident-registration": typeof AdminResidentsResidentRegistrationRoute
  "/admin/residents": typeof AdminModulesElderCareResidentsRouteWithChildren
  "/admin/visitor-inquiry": typeof AdminResidentsVisitorInquiryRoute
  "/admin/visitors": typeof AdminResidentsVisitorsRoute
  "/admin/staff-roles": typeof AdminSystemStaffRolesRoute
  "/admin/user-permissions": typeof AdminUserRolesUserPermissionsRoute
  "/admin/gallery": typeof AdminWebsiteGalleryRoute
  "/admin/posts": typeof AdminWebsitePostsRoute
  "/admin/trustees": typeof AdminWebsiteTrusteesRoute
  "/admin/tiffin-seva/applications": typeof AdminTiffinSevaApplicationsRoute
  "/admin/tiffin-seva/dashboard": typeof AdminTiffinSevaDashboardRoute
  "/admin/tiffin-seva/donations": typeof AdminTiffinSevaDonationsRoute
  "/donate/thank-you/$ref": typeof DonateThankYouRefRoute
  "/healthcare/$id": typeof UserCareHealthcareIdRoute
  "/admin/admission-applications/$id": typeof AdminAdmissionsAdmissionApplicationsIdRoute
  "/admin/elder-care": typeof AdminModulesElderCareElderCareRoute
  "/admin/animals": typeof AdminModulesGaushalaAnimalsRoute
  "/admin/gaushala": typeof AdminModulesGaushalaGaushalaRoute
  "/admin/franchise-enquiries": typeof AdminModulesGruhUdhyogFranchiseEnquiriesRoute
  "/admin/gruh-udhyog": typeof AdminModulesGruhUdhyogGruhUdhyogRoute
  "/admin/gruh-udhyog-inventory": typeof AdminModulesGruhUdhyogGruhUdhyogInventoryRoute
  "/admin/product-categories": typeof AdminModulesGruhUdhyogProductCategoriesRoute
  "/admin/product-orders": typeof AdminModulesGruhUdhyogProductOrdersRoute
  "/admin/product-variants": typeof AdminModulesGruhUdhyogProductVariantsRoute
  "/admin/products": typeof AdminModulesGruhUdhyogProductsRoute
  "/admin/stock-entries": typeof AdminModulesGruhUdhyogStockEntriesRoute
  "/admin/healthcare": typeof AdminModulesHealthcareHealthcareRoute
  "/admin/healthcare-donations": typeof AdminModulesHealthcareHealthcareDonationsRoute
  "/admin/healthcare-management": typeof AdminModulesHealthcareHealthcareManagementRoute
  "/admin/hospital-profile": typeof AdminModulesHealthcareHospitalProfileRoute
  "/admin/medical-staff": typeof AdminModulesHealthcareMedicalStaffRoute
  "/donate/c/$kind/$id": typeof DonateCKindIdRoute
  "/healthcare/": typeof UserCareHealthcareIndexRoute
  "/admin/inventory/": typeof AdminModulesGruhUdhyogInventoryRoute
  "/admin/residents/$id": typeof AdminModulesElderCareResidentsIdRoute
}
export interface FileRoutesByTo {
  "/about": typeof UserAboutRoute
  "/account": typeof UserAccountRoute
  "/contact": typeof UserContactRoute
  "/csr-partnership": typeof UserCsrPartnershipRoute
  "/login": typeof UserLoginRoute
  "/signup": typeof UserSignupRoute
  "/donate/general": typeof DonateGeneralRoute
  "/donate/inkind": typeof DonateInkindRoute
  "/donate/items": typeof DonateItemsRoute
  "/donate/scrap": typeof DonateScrapRoute
  "/": typeof UserIndexRoute
  "/admin": typeof AdminIndexRoute
  "/donate": typeof DonateIndexRoute
  "/admission-inquiry": typeof UserAdmissionAdmissionInquiryRoute
  "/apply-admission": typeof UserAdmissionApplyAdmissionRoute
  "/elder-care-program": typeof UserCareElderCareProgramRoute
  "/resident-care": typeof UserCareResidentCareRoute
  "/events": typeof UserCommunityEventsRoute
  "/feedback": typeof UserCommunityFeedbackRoute
  "/gallery": typeof UserCommunityGalleryRoute
  "/jain-panchang": typeof UserCommunityJainPanchangRoute
  "/news": typeof UserCommunityNewsRoute
  "/visitor-form": typeof UserCommunityVisitorFormRoute
  "/visitor-inquiry": typeof UserCommunityVisitorInquiryRoute
  "/bhojanshala": typeof UserProgramsBhojanshalaRoute
  "/gaushala": typeof UserProgramsGaushalaRoute
  "/gruh-udhyog": typeof UserProgramsGruhUdhyogRoute
  "/tiffin-seva": typeof UserProgramsTiffinSevaRoute
  "/transparency": typeof UserTrustTransparencyRoute
  "/trustees": typeof UserTrustTrusteesRoute
  "/admin/admission-applications": typeof AdminAdmissionsAdmissionApplicationsRouteWithChildren
  "/admin/admission-approval": typeof AdminAdmissionsAdmissionApprovalRoute
  "/admin/admission-inquiry": typeof AdminAdmissionsAdmissionInquiryRoute
  "/admin/admission-recommendation": typeof AdminAdmissionsAdmissionRecommendationRoute
  "/admin/elder-registration": typeof AdminAdmissionsElderRegistrationRoute
  "/admin/family-details": typeof AdminAdmissionsFamilyDetailsRoute
  "/admin/bhojan-categories": typeof AdminBhojanshalaBhojanCategoriesRoute
  "/admin/bhojan-donations": typeof AdminBhojanshalaBhojanDonationsRoute
  "/admin/bhojan-packages": typeof AdminBhojanshalaBhojanPackagesRoute
  "/admin/bhojan-schemes": typeof AdminBhojanshalaBhojanSchemesRoute
  "/admin/campaigns": typeof AdminDonationSetupCampaignsRoute
  "/admin/donation-masters": typeof AdminDonationSetupDonationMastersRoute
  "/admin/events": typeof AdminDonationSetupEventsRoute
  "/admin/infrastructure": typeof AdminDonationSetupInfrastructureRoute
  "/admin/inkind": typeof AdminDonationSetupInkindRoute
  "/admin/item-categories": typeof AdminDonationSetupItemCategoriesRoute
  "/admin/payment-settings": typeof AdminDonationSetupPaymentSettingsRoute
  "/admin/seva": typeof AdminDonationSetupSevaRoute
  "/admin/donations": typeof AdminDonationsDonationsRoute
  "/admin/donors": typeof AdminDonationsDonorsRoute
  "/admin/medical": typeof AdminDonationsMedicalRoute
  "/admin/receipts": typeof AdminDonationsReceiptsRoute
  "/admin/recurring": typeof AdminDonationsRecurringRoute
  "/admin/scrap-donations": typeof AdminDonationsScrapDonationsRoute
  "/admin/csr-inquiries": typeof AdminEngagementCsrInquiriesRoute
  "/admin/feedback": typeof AdminEngagementFeedbackRoute
  "/admin/inquiries": typeof AdminEngagementInquiriesRoute
  "/admin/punya-tithi": typeof AdminEngagementPunyaTithiRoute
  "/admin/tiffin": typeof AdminEngagementTiffinRoute
  "/admin/gaushala-donations": typeof AdminGaushalaGaushalaDonationsRoute
  "/admin/gaushala-schemes": typeof AdminGaushalaGaushalaSchemesRoute
  "/admin/vrindavan-gaushala": typeof AdminGaushalaVrindavanGaushalaRoute
  "/admin/areas": typeof AdminListMasterAreasRoute
  "/admin/cities": typeof AdminListMasterCitiesRoute
  "/admin/districts": typeof AdminListMasterDistrictsRoute
  "/admin/festivals": typeof AdminListMasterFestivalsRoute
  "/admin/jain-panchang": typeof AdminListMasterJainPanchangRoute
  "/admin/relationships": typeof AdminListMasterRelationshipsRoute
  "/admin/treatment-master": typeof AdminListMasterTreatmentMasterRoute
  "/admin/manual-receipts": typeof AdminManualReceiptManualReceiptsRoute
  "/admin/communication": typeof AdminModulesCommunicationRoute
  "/admin/community-events": typeof AdminModulesCommunityEventsRoute
  "/admin/event-categories": typeof AdminModulesEventCategoriesRoute
  "/admin/hr-payroll": typeof AdminModulesHrPayrollRoute
  "/admin/inventory": typeof AdminModulesGruhUdhyogInventoryRoute
  "/admin/ai-studio": typeof AdminOverviewAiStudioRoute
  "/admin/dashboard": typeof AdminOverviewDashboardRoute
  "/admin/reports": typeof AdminOverviewReportsRoute
  "/admin/adoption": typeof AdminResidentsAdoptionRoute
  "/admin/resident-death": typeof AdminResidentsResidentDeathRoute
  "/admin/resident-family": typeof AdminResidentsResidentFamilyRoute
  "/admin/resident-registration": typeof AdminResidentsResidentRegistrationRoute
  "/admin/residents": typeof AdminModulesElderCareResidentsRouteWithChildren
  "/admin/visitor-inquiry": typeof AdminResidentsVisitorInquiryRoute
  "/admin/visitors": typeof AdminResidentsVisitorsRoute
  "/admin/staff-roles": typeof AdminSystemStaffRolesRoute
  "/admin/user-permissions": typeof AdminUserRolesUserPermissionsRoute
  "/admin/gallery": typeof AdminWebsiteGalleryRoute
  "/admin/posts": typeof AdminWebsitePostsRoute
  "/admin/trustees": typeof AdminWebsiteTrusteesRoute
  "/admin/tiffin-seva/applications": typeof AdminTiffinSevaApplicationsRoute
  "/admin/tiffin-seva/dashboard": typeof AdminTiffinSevaDashboardRoute
  "/admin/tiffin-seva/donations": typeof AdminTiffinSevaDonationsRoute
  "/donate/thank-you/$ref": typeof DonateThankYouRefRoute
  "/healthcare/$id": typeof UserCareHealthcareIdRoute
  "/admin/admission-applications/$id": typeof AdminAdmissionsAdmissionApplicationsIdRoute
  "/admin/elder-care": typeof AdminModulesElderCareElderCareRoute
  "/admin/animals": typeof AdminModulesGaushalaAnimalsRoute
  "/admin/gaushala": typeof AdminModulesGaushalaGaushalaRoute
  "/admin/franchise-enquiries": typeof AdminModulesGruhUdhyogFranchiseEnquiriesRoute
  "/admin/gruh-udhyog": typeof AdminModulesGruhUdhyogGruhUdhyogRoute
  "/admin/gruh-udhyog-inventory": typeof AdminModulesGruhUdhyogGruhUdhyogInventoryRoute
  "/admin/product-categories": typeof AdminModulesGruhUdhyogProductCategoriesRoute
  "/admin/product-orders": typeof AdminModulesGruhUdhyogProductOrdersRoute
  "/admin/product-variants": typeof AdminModulesGruhUdhyogProductVariantsRoute
  "/admin/products": typeof AdminModulesGruhUdhyogProductsRoute
  "/admin/stock-entries": typeof AdminModulesGruhUdhyogStockEntriesRoute
  "/admin/healthcare": typeof AdminModulesHealthcareHealthcareRoute
  "/admin/healthcare-donations": typeof AdminModulesHealthcareHealthcareDonationsRoute
  "/admin/healthcare-management": typeof AdminModulesHealthcareHealthcareManagementRoute
  "/admin/hospital-profile": typeof AdminModulesHealthcareHospitalProfileRoute
  "/admin/medical-staff": typeof AdminModulesHealthcareMedicalStaffRoute
  "/donate/c/$kind/$id": typeof DonateCKindIdRoute
  "/healthcare": typeof UserCareHealthcareIndexRoute
  "/admin/residents/$id": typeof AdminModulesElderCareResidentsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/donate": typeof DonateRouteRouteWithChildren
  "/_user/about": typeof UserAboutRoute
  "/_user/account": typeof UserAccountRoute
  "/_user/contact": typeof UserContactRoute
  "/_user/csr-partnership": typeof UserCsrPartnershipRoute
  "/_user/login": typeof UserLoginRoute
  "/_user/signup": typeof UserSignupRoute
  "/donate/general": typeof DonateGeneralRoute
  "/donate/inkind": typeof DonateInkindRoute
  "/donate/items": typeof DonateItemsRoute
  "/donate/scrap": typeof DonateScrapRoute
  "/_user/": typeof UserIndexRoute
  "/admin/": typeof AdminIndexRoute
  "/donate/": typeof DonateIndexRoute
  "/_user/_admission/admission-inquiry": typeof UserAdmissionAdmissionInquiryRoute
  "/_user/_admission/apply-admission": typeof UserAdmissionApplyAdmissionRoute
  "/_user/_care/elder-care-program": typeof UserCareElderCareProgramRoute
  "/_user/_care/healthcare": typeof UserCareHealthcareRouteWithChildren
  "/_user/_care/resident-care": typeof UserCareResidentCareRoute
  "/_user/_community/events": typeof UserCommunityEventsRoute
  "/_user/_community/feedback": typeof UserCommunityFeedbackRoute
  "/_user/_community/gallery": typeof UserCommunityGalleryRoute
  "/_user/_community/jain-panchang": typeof UserCommunityJainPanchangRoute
  "/_user/_community/news": typeof UserCommunityNewsRoute
  "/_user/_community/visitor-form": typeof UserCommunityVisitorFormRoute
  "/_user/_community/visitor-inquiry": typeof UserCommunityVisitorInquiryRoute
  "/_user/_programs/bhojanshala": typeof UserProgramsBhojanshalaRoute
  "/_user/_programs/gaushala": typeof UserProgramsGaushalaRoute
  "/_user/_programs/gruh-udhyog": typeof UserProgramsGruhUdhyogRoute
  "/_user/_programs/tiffin-seva": typeof UserProgramsTiffinSevaRoute
  "/_user/_trust/transparency": typeof UserTrustTransparencyRoute
  "/_user/_trust/trustees": typeof UserTrustTrusteesRoute
  "/admin/_admissions/admission-applications": typeof AdminAdmissionsAdmissionApplicationsRouteWithChildren
  "/admin/_admissions/admission-approval": typeof AdminAdmissionsAdmissionApprovalRoute
  "/admin/_admissions/admission-inquiry": typeof AdminAdmissionsAdmissionInquiryRoute
  "/admin/_admissions/admission-recommendation": typeof AdminAdmissionsAdmissionRecommendationRoute
  "/admin/_admissions/elder-registration": typeof AdminAdmissionsElderRegistrationRoute
  "/admin/_admissions/family-details": typeof AdminAdmissionsFamilyDetailsRoute
  "/admin/_bhojanshala/bhojan-categories": typeof AdminBhojanshalaBhojanCategoriesRoute
  "/admin/_bhojanshala/bhojan-donations": typeof AdminBhojanshalaBhojanDonationsRoute
  "/admin/_bhojanshala/bhojan-packages": typeof AdminBhojanshalaBhojanPackagesRoute
  "/admin/_bhojanshala/bhojan-schemes": typeof AdminBhojanshalaBhojanSchemesRoute
  "/admin/_donation-setup/campaigns": typeof AdminDonationSetupCampaignsRoute
  "/admin/_donation-setup/donation-masters": typeof AdminDonationSetupDonationMastersRoute
  "/admin/_donation-setup/events": typeof AdminDonationSetupEventsRoute
  "/admin/_donation-setup/infrastructure": typeof AdminDonationSetupInfrastructureRoute
  "/admin/_donation-setup/inkind": typeof AdminDonationSetupInkindRoute
  "/admin/_donation-setup/item-categories": typeof AdminDonationSetupItemCategoriesRoute
  "/admin/_donation-setup/payment-settings": typeof AdminDonationSetupPaymentSettingsRoute
  "/admin/_donation-setup/seva": typeof AdminDonationSetupSevaRoute
  "/admin/_donations/donations": typeof AdminDonationsDonationsRoute
  "/admin/_donations/donors": typeof AdminDonationsDonorsRoute
  "/admin/_donations/medical": typeof AdminDonationsMedicalRoute
  "/admin/_donations/receipts": typeof AdminDonationsReceiptsRoute
  "/admin/_donations/recurring": typeof AdminDonationsRecurringRoute
  "/admin/_donations/scrap-donations": typeof AdminDonationsScrapDonationsRoute
  "/admin/_engagement/csr-inquiries": typeof AdminEngagementCsrInquiriesRoute
  "/admin/_engagement/feedback": typeof AdminEngagementFeedbackRoute
  "/admin/_engagement/inquiries": typeof AdminEngagementInquiriesRoute
  "/admin/_engagement/punya-tithi": typeof AdminEngagementPunyaTithiRoute
  "/admin/_engagement/tiffin": typeof AdminEngagementTiffinRoute
  "/admin/_gaushala/gaushala-donations": typeof AdminGaushalaGaushalaDonationsRoute
  "/admin/_gaushala/gaushala-schemes": typeof AdminGaushalaGaushalaSchemesRoute
  "/admin/_gaushala/vrindavan-gaushala": typeof AdminGaushalaVrindavanGaushalaRoute
  "/admin/_list-master/areas": typeof AdminListMasterAreasRoute
  "/admin/_list-master/cities": typeof AdminListMasterCitiesRoute
  "/admin/_list-master/districts": typeof AdminListMasterDistrictsRoute
  "/admin/_list-master/festivals": typeof AdminListMasterFestivalsRoute
  "/admin/_list-master/jain-panchang": typeof AdminListMasterJainPanchangRoute
  "/admin/_list-master/relationships": typeof AdminListMasterRelationshipsRoute
  "/admin/_list-master/treatment-master": typeof AdminListMasterTreatmentMasterRoute
  "/admin/_manual-receipt/manual-receipts": typeof AdminManualReceiptManualReceiptsRoute
  "/admin/_modules/communication": typeof AdminModulesCommunicationRoute
  "/admin/_modules/community-events": typeof AdminModulesCommunityEventsRoute
  "/admin/_modules/event-categories": typeof AdminModulesEventCategoriesRoute
  "/admin/_modules/hr-payroll": typeof AdminModulesHrPayrollRoute
  "/admin/_modules/inventory": typeof AdminModulesInventoryRoute
  "/admin/_overview/ai-studio": typeof AdminOverviewAiStudioRoute
  "/admin/_overview/dashboard": typeof AdminOverviewDashboardRoute
  "/admin/_overview/reports": typeof AdminOverviewReportsRoute
  "/admin/_residents/adoption": typeof AdminResidentsAdoptionRoute
  "/admin/_residents/resident-death": typeof AdminResidentsResidentDeathRoute
  "/admin/_residents/resident-family": typeof AdminResidentsResidentFamilyRoute
  "/admin/_residents/resident-registration": typeof AdminResidentsResidentRegistrationRoute
  "/admin/_residents/residents": typeof AdminResidentsResidentsRoute
  "/admin/_residents/visitor-inquiry": typeof AdminResidentsVisitorInquiryRoute
  "/admin/_residents/visitors": typeof AdminResidentsVisitorsRoute
  "/admin/_system/staff-roles": typeof AdminSystemStaffRolesRoute
  "/admin/_user-roles/user-permissions": typeof AdminUserRolesUserPermissionsRoute
  "/admin/_website/gallery": typeof AdminWebsiteGalleryRoute
  "/admin/_website/posts": typeof AdminWebsitePostsRoute
  "/admin/_website/trustees": typeof AdminWebsiteTrusteesRoute
  "/admin/tiffin-seva/applications": typeof AdminTiffinSevaApplicationsRoute
  "/admin/tiffin-seva/dashboard": typeof AdminTiffinSevaDashboardRoute
  "/admin/tiffin-seva/donations": typeof AdminTiffinSevaDonationsRoute
  "/donate/thank-you/$ref": typeof DonateThankYouRefRoute
  "/_user/_care/healthcare/$id": typeof UserCareHealthcareIdRoute
  "/admin/_admissions/admission-applications/$id": typeof AdminAdmissionsAdmissionApplicationsIdRoute
  "/admin/_modules/_elder-care/elder-care": typeof AdminModulesElderCareElderCareRoute
  "/admin/_modules/_elder-care/residents": typeof AdminModulesElderCareResidentsRouteWithChildren
  "/admin/_modules/_gaushala/animals": typeof AdminModulesGaushalaAnimalsRoute
  "/admin/_modules/_gaushala/gaushala": typeof AdminModulesGaushalaGaushalaRoute
  "/admin/_modules/_gruh-udhyog/franchise-enquiries": typeof AdminModulesGruhUdhyogFranchiseEnquiriesRoute
  "/admin/_modules/_gruh-udhyog/gruh-udhyog": typeof AdminModulesGruhUdhyogGruhUdhyogRoute
  "/admin/_modules/_gruh-udhyog/gruh-udhyog-inventory": typeof AdminModulesGruhUdhyogGruhUdhyogInventoryRoute
  "/admin/_modules/_gruh-udhyog/product-categories": typeof AdminModulesGruhUdhyogProductCategoriesRoute
  "/admin/_modules/_gruh-udhyog/product-orders": typeof AdminModulesGruhUdhyogProductOrdersRoute
  "/admin/_modules/_gruh-udhyog/product-variants": typeof AdminModulesGruhUdhyogProductVariantsRoute
  "/admin/_modules/_gruh-udhyog/products": typeof AdminModulesGruhUdhyogProductsRoute
  "/admin/_modules/_gruh-udhyog/stock-entries": typeof AdminModulesGruhUdhyogStockEntriesRoute
  "/admin/_modules/_healthcare/healthcare": typeof AdminModulesHealthcareHealthcareRoute
  "/admin/_modules/_healthcare/healthcare-donations": typeof AdminModulesHealthcareHealthcareDonationsRoute
  "/admin/_modules/_healthcare/healthcare-management": typeof AdminModulesHealthcareHealthcareManagementRoute
  "/admin/_modules/_healthcare/hospital-profile": typeof AdminModulesHealthcareHospitalProfileRoute
  "/admin/_modules/_healthcare/medical-staff": typeof AdminModulesHealthcareMedicalStaffRoute
  "/donate/c/$kind/$id": typeof DonateCKindIdRoute
  "/_user/_care/healthcare/": typeof UserCareHealthcareIndexRoute
  "/admin/_modules/_gruh-udhyog/inventory/": typeof AdminModulesGruhUdhyogInventoryRoute
  "/admin/_modules/_elder-care/residents/$id": typeof AdminModulesElderCareResidentsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/donate"
    | "/about"
    | "/account"
    | "/contact"
    | "/csr-partnership"
    | "/login"
    | "/signup"
    | "/donate/general"
    | "/donate/inkind"
    | "/donate/items"
    | "/donate/scrap"
    | "/"
    | "/admin/"
    | "/donate/"
    | "/admission-inquiry"
    | "/apply-admission"
    | "/elder-care-program"
    | "/healthcare"
    | "/resident-care"
    | "/events"
    | "/feedback"
    | "/gallery"
    | "/jain-panchang"
    | "/news"
    | "/visitor-form"
    | "/visitor-inquiry"
    | "/bhojanshala"
    | "/gaushala"
    | "/gruh-udhyog"
    | "/tiffin-seva"
    | "/transparency"
    | "/trustees"
    | "/admin/admission-applications"
    | "/admin/admission-approval"
    | "/admin/admission-inquiry"
    | "/admin/admission-recommendation"
    | "/admin/elder-registration"
    | "/admin/family-details"
    | "/admin/bhojan-categories"
    | "/admin/bhojan-donations"
    | "/admin/bhojan-packages"
    | "/admin/bhojan-schemes"
    | "/admin/campaigns"
    | "/admin/donation-masters"
    | "/admin/events"
    | "/admin/infrastructure"
    | "/admin/inkind"
    | "/admin/item-categories"
    | "/admin/payment-settings"
    | "/admin/seva"
    | "/admin/donations"
    | "/admin/donors"
    | "/admin/medical"
    | "/admin/receipts"
    | "/admin/recurring"
    | "/admin/scrap-donations"
    | "/admin/csr-inquiries"
    | "/admin/feedback"
    | "/admin/inquiries"
    | "/admin/punya-tithi"
    | "/admin/tiffin"
    | "/admin/gaushala-donations"
    | "/admin/gaushala-schemes"
    | "/admin/vrindavan-gaushala"
    | "/admin/areas"
    | "/admin/cities"
    | "/admin/districts"
    | "/admin/festivals"
    | "/admin/jain-panchang"
    | "/admin/relationships"
    | "/admin/treatment-master"
    | "/admin/manual-receipts"
    | "/admin/communication"
    | "/admin/community-events"
    | "/admin/event-categories"
    | "/admin/hr-payroll"
    | "/admin/inventory"
    | "/admin/ai-studio"
    | "/admin/dashboard"
    | "/admin/reports"
    | "/admin/adoption"
    | "/admin/resident-death"
    | "/admin/resident-family"
    | "/admin/resident-registration"
    | "/admin/residents"
    | "/admin/visitor-inquiry"
    | "/admin/visitors"
    | "/admin/staff-roles"
    | "/admin/user-permissions"
    | "/admin/gallery"
    | "/admin/posts"
    | "/admin/trustees"
    | "/admin/tiffin-seva/applications"
    | "/admin/tiffin-seva/dashboard"
    | "/admin/tiffin-seva/donations"
    | "/donate/thank-you/$ref"
    | "/healthcare/$id"
    | "/admin/admission-applications/$id"
    | "/admin/elder-care"
    | "/admin/animals"
    | "/admin/gaushala"
    | "/admin/franchise-enquiries"
    | "/admin/gruh-udhyog"
    | "/admin/gruh-udhyog-inventory"
    | "/admin/product-categories"
    | "/admin/product-orders"
    | "/admin/product-variants"
    | "/admin/products"
    | "/admin/stock-entries"
    | "/admin/healthcare"
    | "/admin/healthcare-donations"
    | "/admin/healthcare-management"
    | "/admin/hospital-profile"
    | "/admin/medical-staff"
    | "/donate/c/$kind/$id"
    | "/healthcare/"
    | "/admin/inventory/"
    | "/admin/residents/$id"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/about"
    | "/account"
    | "/contact"
    | "/csr-partnership"
    | "/login"
    | "/signup"
    | "/donate/general"
    | "/donate/inkind"
    | "/donate/items"
    | "/donate/scrap"
    | "/"
    | "/admin"
    | "/donate"
    | "/admission-inquiry"
    | "/apply-admission"
    | "/elder-care-program"
    | "/resident-care"
    | "/events"
    | "/feedback"
    | "/gallery"
    | "/jain-panchang"
    | "/news"
    | "/visitor-form"
    | "/visitor-inquiry"
    | "/bhojanshala"
    | "/gaushala"
    | "/gruh-udhyog"
    | "/tiffin-seva"
    | "/transparency"
    | "/trustees"
    | "/admin/admission-applications"
    | "/admin/admission-approval"
    | "/admin/admission-inquiry"
    | "/admin/admission-recommendation"
    | "/admin/elder-registration"
    | "/admin/family-details"
    | "/admin/bhojan-categories"
    | "/admin/bhojan-donations"
    | "/admin/bhojan-packages"
    | "/admin/bhojan-schemes"
    | "/admin/campaigns"
    | "/admin/donation-masters"
    | "/admin/events"
    | "/admin/infrastructure"
    | "/admin/inkind"
    | "/admin/item-categories"
    | "/admin/payment-settings"
    | "/admin/seva"
    | "/admin/donations"
    | "/admin/donors"
    | "/admin/medical"
    | "/admin/receipts"
    | "/admin/recurring"
    | "/admin/scrap-donations"
    | "/admin/csr-inquiries"
    | "/admin/feedback"
    | "/admin/inquiries"
    | "/admin/punya-tithi"
    | "/admin/tiffin"
    | "/admin/gaushala-donations"
    | "/admin/gaushala-schemes"
    | "/admin/vrindavan-gaushala"
    | "/admin/areas"
    | "/admin/cities"
    | "/admin/districts"
    | "/admin/festivals"
    | "/admin/jain-panchang"
    | "/admin/relationships"
    | "/admin/treatment-master"
    | "/admin/manual-receipts"
    | "/admin/communication"
    | "/admin/community-events"
    | "/admin/event-categories"
    | "/admin/hr-payroll"
    | "/admin/inventory"
    | "/admin/ai-studio"
    | "/admin/dashboard"
    | "/admin/reports"
    | "/admin/adoption"
    | "/admin/resident-death"
    | "/admin/resident-family"
    | "/admin/resident-registration"
    | "/admin/residents"
    | "/admin/visitor-inquiry"
    | "/admin/visitors"
    | "/admin/staff-roles"
    | "/admin/user-permissions"
    | "/admin/gallery"
    | "/admin/posts"
    | "/admin/trustees"
    | "/admin/tiffin-seva/applications"
    | "/admin/tiffin-seva/dashboard"
    | "/admin/tiffin-seva/donations"
    | "/donate/thank-you/$ref"
    | "/healthcare/$id"
    | "/admin/admission-applications/$id"
    | "/admin/elder-care"
    | "/admin/animals"
    | "/admin/gaushala"
    | "/admin/franchise-enquiries"
    | "/admin/gruh-udhyog"
    | "/admin/gruh-udhyog-inventory"
    | "/admin/product-categories"
    | "/admin/product-orders"
    | "/admin/product-variants"
    | "/admin/products"
    | "/admin/stock-entries"
    | "/admin/healthcare"
    | "/admin/healthcare-donations"
    | "/admin/healthcare-management"
    | "/admin/hospital-profile"
    | "/admin/medical-staff"
    | "/donate/c/$kind/$id"
    | "/healthcare"
    | "/admin/residents/$id"
  id:
    | "__root__"
    | "/donate"
    | "/_user/about"
    | "/_user/account"
    | "/_user/contact"
    | "/_user/csr-partnership"
    | "/_user/login"
    | "/_user/signup"
    | "/donate/general"
    | "/donate/inkind"
    | "/donate/items"
    | "/donate/scrap"
    | "/_user/"
    | "/admin/"
    | "/donate/"
    | "/_user/_admission/admission-inquiry"
    | "/_user/_admission/apply-admission"
    | "/_user/_care/elder-care-program"
    | "/_user/_care/healthcare"
    | "/_user/_care/resident-care"
    | "/_user/_community/events"
    | "/_user/_community/feedback"
    | "/_user/_community/gallery"
    | "/_user/_community/jain-panchang"
    | "/_user/_community/news"
    | "/_user/_community/visitor-form"
    | "/_user/_community/visitor-inquiry"
    | "/_user/_programs/bhojanshala"
    | "/_user/_programs/gaushala"
    | "/_user/_programs/gruh-udhyog"
    | "/_user/_programs/tiffin-seva"
    | "/_user/_trust/transparency"
    | "/_user/_trust/trustees"
    | "/admin/_admissions/admission-applications"
    | "/admin/_admissions/admission-approval"
    | "/admin/_admissions/admission-inquiry"
    | "/admin/_admissions/admission-recommendation"
    | "/admin/_admissions/elder-registration"
    | "/admin/_admissions/family-details"
    | "/admin/_bhojanshala/bhojan-categories"
    | "/admin/_bhojanshala/bhojan-donations"
    | "/admin/_bhojanshala/bhojan-packages"
    | "/admin/_bhojanshala/bhojan-schemes"
    | "/admin/_donation-setup/campaigns"
    | "/admin/_donation-setup/donation-masters"
    | "/admin/_donation-setup/events"
    | "/admin/_donation-setup/infrastructure"
    | "/admin/_donation-setup/inkind"
    | "/admin/_donation-setup/item-categories"
    | "/admin/_donation-setup/payment-settings"
    | "/admin/_donation-setup/seva"
    | "/admin/_donations/donations"
    | "/admin/_donations/donors"
    | "/admin/_donations/medical"
    | "/admin/_donations/receipts"
    | "/admin/_donations/recurring"
    | "/admin/_donations/scrap-donations"
    | "/admin/_engagement/csr-inquiries"
    | "/admin/_engagement/feedback"
    | "/admin/_engagement/inquiries"
    | "/admin/_engagement/punya-tithi"
    | "/admin/_engagement/tiffin"
    | "/admin/_gaushala/gaushala-donations"
    | "/admin/_gaushala/gaushala-schemes"
    | "/admin/_gaushala/vrindavan-gaushala"
    | "/admin/_list-master/areas"
    | "/admin/_list-master/cities"
    | "/admin/_list-master/districts"
    | "/admin/_list-master/festivals"
    | "/admin/_list-master/jain-panchang"
    | "/admin/_list-master/relationships"
    | "/admin/_list-master/treatment-master"
    | "/admin/_manual-receipt/manual-receipts"
    | "/admin/_modules/communication"
    | "/admin/_modules/community-events"
    | "/admin/_modules/event-categories"
    | "/admin/_modules/hr-payroll"
    | "/admin/_modules/inventory"
    | "/admin/_overview/ai-studio"
    | "/admin/_overview/dashboard"
    | "/admin/_overview/reports"
    | "/admin/_residents/adoption"
    | "/admin/_residents/resident-death"
    | "/admin/_residents/resident-family"
    | "/admin/_residents/resident-registration"
    | "/admin/_residents/residents"
    | "/admin/_residents/visitor-inquiry"
    | "/admin/_residents/visitors"
    | "/admin/_system/staff-roles"
    | "/admin/_user-roles/user-permissions"
    | "/admin/_website/gallery"
    | "/admin/_website/posts"
    | "/admin/_website/trustees"
    | "/admin/tiffin-seva/applications"
    | "/admin/tiffin-seva/dashboard"
    | "/admin/tiffin-seva/donations"
    | "/donate/thank-you/$ref"
    | "/_user/_care/healthcare/$id"
    | "/admin/_admissions/admission-applications/$id"
    | "/admin/_modules/_elder-care/elder-care"
    | "/admin/_modules/_elder-care/residents"
    | "/admin/_modules/_gaushala/animals"
    | "/admin/_modules/_gaushala/gaushala"
    | "/admin/_modules/_gruh-udhyog/franchise-enquiries"
    | "/admin/_modules/_gruh-udhyog/gruh-udhyog"
    | "/admin/_modules/_gruh-udhyog/gruh-udhyog-inventory"
    | "/admin/_modules/_gruh-udhyog/product-categories"
    | "/admin/_modules/_gruh-udhyog/product-orders"
    | "/admin/_modules/_gruh-udhyog/product-variants"
    | "/admin/_modules/_gruh-udhyog/products"
    | "/admin/_modules/_gruh-udhyog/stock-entries"
    | "/admin/_modules/_healthcare/healthcare"
    | "/admin/_modules/_healthcare/healthcare-donations"
    | "/admin/_modules/_healthcare/healthcare-management"
    | "/admin/_modules/_healthcare/hospital-profile"
    | "/admin/_modules/_healthcare/medical-staff"
    | "/donate/c/$kind/$id"
    | "/_user/_care/healthcare/"
    | "/admin/_modules/_gruh-udhyog/inventory/"
    | "/admin/_modules/_elder-care/residents/$id"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DonateRouteRoute: typeof DonateRouteRouteWithChildren
  UserAboutRoute: typeof UserAboutRoute
  UserAccountRoute: typeof UserAccountRoute
  UserContactRoute: typeof UserContactRoute
  UserCsrPartnershipRoute: typeof UserCsrPartnershipRoute
  UserLoginRoute: typeof UserLoginRoute
  UserSignupRoute: typeof UserSignupRoute
  UserIndexRoute: typeof UserIndexRoute
  AdminIndexRoute: typeof AdminIndexRoute
  UserAdmissionAdmissionInquiryRoute: typeof UserAdmissionAdmissionInquiryRoute
  UserAdmissionApplyAdmissionRoute: typeof UserAdmissionApplyAdmissionRoute
  UserCareElderCareProgramRoute: typeof UserCareElderCareProgramRoute
  UserCareHealthcareRoute: typeof UserCareHealthcareRouteWithChildren
  UserCareResidentCareRoute: typeof UserCareResidentCareRoute
  UserCommunityEventsRoute: typeof UserCommunityEventsRoute
  UserCommunityFeedbackRoute: typeof UserCommunityFeedbackRoute
  UserCommunityGalleryRoute: typeof UserCommunityGalleryRoute
  UserCommunityJainPanchangRoute: typeof UserCommunityJainPanchangRoute
  UserCommunityNewsRoute: typeof UserCommunityNewsRoute
  UserCommunityVisitorFormRoute: typeof UserCommunityVisitorFormRoute
  UserCommunityVisitorInquiryRoute: typeof UserCommunityVisitorInquiryRoute
  UserProgramsBhojanshalaRoute: typeof UserProgramsBhojanshalaRoute
  UserProgramsGaushalaRoute: typeof UserProgramsGaushalaRoute
  UserProgramsGruhUdhyogRoute: typeof UserProgramsGruhUdhyogRoute
  UserProgramsTiffinSevaRoute: typeof UserProgramsTiffinSevaRoute
  UserTrustTransparencyRoute: typeof UserTrustTransparencyRoute
  UserTrustTrusteesRoute: typeof UserTrustTrusteesRoute
  AdminAdmissionsAdmissionApplicationsRoute: typeof AdminAdmissionsAdmissionApplicationsRouteWithChildren
  AdminAdmissionsAdmissionApprovalRoute: typeof AdminAdmissionsAdmissionApprovalRoute
  AdminAdmissionsAdmissionInquiryRoute: typeof AdminAdmissionsAdmissionInquiryRoute
  AdminAdmissionsAdmissionRecommendationRoute: typeof AdminAdmissionsAdmissionRecommendationRoute
  AdminAdmissionsElderRegistrationRoute: typeof AdminAdmissionsElderRegistrationRoute
  AdminAdmissionsFamilyDetailsRoute: typeof AdminAdmissionsFamilyDetailsRoute
  AdminBhojanshalaBhojanCategoriesRoute: typeof AdminBhojanshalaBhojanCategoriesRoute
  AdminBhojanshalaBhojanDonationsRoute: typeof AdminBhojanshalaBhojanDonationsRoute
  AdminBhojanshalaBhojanPackagesRoute: typeof AdminBhojanshalaBhojanPackagesRoute
  AdminBhojanshalaBhojanSchemesRoute: typeof AdminBhojanshalaBhojanSchemesRoute
  AdminDonationSetupCampaignsRoute: typeof AdminDonationSetupCampaignsRoute
  AdminDonationSetupDonationMastersRoute: typeof AdminDonationSetupDonationMastersRoute
  AdminDonationSetupEventsRoute: typeof AdminDonationSetupEventsRoute
  AdminDonationSetupInfrastructureRoute: typeof AdminDonationSetupInfrastructureRoute
  AdminDonationSetupInkindRoute: typeof AdminDonationSetupInkindRoute
  AdminDonationSetupItemCategoriesRoute: typeof AdminDonationSetupItemCategoriesRoute
  AdminDonationSetupPaymentSettingsRoute: typeof AdminDonationSetupPaymentSettingsRoute
  AdminDonationSetupSevaRoute: typeof AdminDonationSetupSevaRoute
  AdminDonationsDonationsRoute: typeof AdminDonationsDonationsRoute
  AdminDonationsDonorsRoute: typeof AdminDonationsDonorsRoute
  AdminDonationsMedicalRoute: typeof AdminDonationsMedicalRoute
  AdminDonationsReceiptsRoute: typeof AdminDonationsReceiptsRoute
  AdminDonationsRecurringRoute: typeof AdminDonationsRecurringRoute
  AdminDonationsScrapDonationsRoute: typeof AdminDonationsScrapDonationsRoute
  AdminEngagementCsrInquiriesRoute: typeof AdminEngagementCsrInquiriesRoute
  AdminEngagementFeedbackRoute: typeof AdminEngagementFeedbackRoute
  AdminEngagementInquiriesRoute: typeof AdminEngagementInquiriesRoute
  AdminEngagementPunyaTithiRoute: typeof AdminEngagementPunyaTithiRoute
  AdminEngagementTiffinRoute: typeof AdminEngagementTiffinRoute
  AdminGaushalaGaushalaDonationsRoute: typeof AdminGaushalaGaushalaDonationsRoute
  AdminGaushalaGaushalaSchemesRoute: typeof AdminGaushalaGaushalaSchemesRoute
  AdminGaushalaVrindavanGaushalaRoute: typeof AdminGaushalaVrindavanGaushalaRoute
  AdminListMasterAreasRoute: typeof AdminListMasterAreasRoute
  AdminListMasterCitiesRoute: typeof AdminListMasterCitiesRoute
  AdminListMasterDistrictsRoute: typeof AdminListMasterDistrictsRoute
  AdminListMasterFestivalsRoute: typeof AdminListMasterFestivalsRoute
  AdminListMasterJainPanchangRoute: typeof AdminListMasterJainPanchangRoute
  AdminListMasterRelationshipsRoute: typeof AdminListMasterRelationshipsRoute
  AdminListMasterTreatmentMasterRoute: typeof AdminListMasterTreatmentMasterRoute
  AdminManualReceiptManualReceiptsRoute: typeof AdminManualReceiptManualReceiptsRoute
  AdminModulesCommunicationRoute: typeof AdminModulesCommunicationRoute
  AdminModulesCommunityEventsRoute: typeof AdminModulesCommunityEventsRoute
  AdminModulesEventCategoriesRoute: typeof AdminModulesEventCategoriesRoute
  AdminModulesHrPayrollRoute: typeof AdminModulesHrPayrollRoute
  AdminModulesInventoryRoute: typeof AdminModulesInventoryRoute
  AdminOverviewAiStudioRoute: typeof AdminOverviewAiStudioRoute
  AdminOverviewDashboardRoute: typeof AdminOverviewDashboardRoute
  AdminOverviewReportsRoute: typeof AdminOverviewReportsRoute
  AdminResidentsAdoptionRoute: typeof AdminResidentsAdoptionRoute
  AdminResidentsResidentDeathRoute: typeof AdminResidentsResidentDeathRoute
  AdminResidentsResidentFamilyRoute: typeof AdminResidentsResidentFamilyRoute
  AdminResidentsResidentRegistrationRoute: typeof AdminResidentsResidentRegistrationRoute
  AdminResidentsResidentsRoute: typeof AdminResidentsResidentsRoute
  AdminResidentsVisitorInquiryRoute: typeof AdminResidentsVisitorInquiryRoute
  AdminResidentsVisitorsRoute: typeof AdminResidentsVisitorsRoute
  AdminSystemStaffRolesRoute: typeof AdminSystemStaffRolesRoute
  AdminUserRolesUserPermissionsRoute: typeof AdminUserRolesUserPermissionsRoute
  AdminWebsiteGalleryRoute: typeof AdminWebsiteGalleryRoute
  AdminWebsitePostsRoute: typeof AdminWebsitePostsRoute
  AdminWebsiteTrusteesRoute: typeof AdminWebsiteTrusteesRoute
  AdminTiffinSevaApplicationsRoute: typeof AdminTiffinSevaApplicationsRoute
  AdminTiffinSevaDashboardRoute: typeof AdminTiffinSevaDashboardRoute
  AdminTiffinSevaDonationsRoute: typeof AdminTiffinSevaDonationsRoute
  AdminModulesElderCareElderCareRoute: typeof AdminModulesElderCareElderCareRoute
  AdminModulesElderCareResidentsRoute: typeof AdminModulesElderCareResidentsRouteWithChildren
  AdminModulesGaushalaAnimalsRoute: typeof AdminModulesGaushalaAnimalsRoute
  AdminModulesGaushalaGaushalaRoute: typeof AdminModulesGaushalaGaushalaRoute
  AdminModulesGruhUdhyogFranchiseEnquiriesRoute: typeof AdminModulesGruhUdhyogFranchiseEnquiriesRoute
  AdminModulesGruhUdhyogGruhUdhyogRoute: typeof AdminModulesGruhUdhyogGruhUdhyogRoute
  AdminModulesGruhUdhyogGruhUdhyogInventoryRoute: typeof AdminModulesGruhUdhyogGruhUdhyogInventoryRoute
  AdminModulesGruhUdhyogProductCategoriesRoute: typeof AdminModulesGruhUdhyogProductCategoriesRoute
  AdminModulesGruhUdhyogProductOrdersRoute: typeof AdminModulesGruhUdhyogProductOrdersRoute
  AdminModulesGruhUdhyogProductVariantsRoute: typeof AdminModulesGruhUdhyogProductVariantsRoute
  AdminModulesGruhUdhyogProductsRoute: typeof AdminModulesGruhUdhyogProductsRoute
  AdminModulesGruhUdhyogStockEntriesRoute: typeof AdminModulesGruhUdhyogStockEntriesRoute
  AdminModulesHealthcareHealthcareRoute: typeof AdminModulesHealthcareHealthcareRoute
  AdminModulesHealthcareHealthcareDonationsRoute: typeof AdminModulesHealthcareHealthcareDonationsRoute
  AdminModulesHealthcareHealthcareManagementRoute: typeof AdminModulesHealthcareHealthcareManagementRoute
  AdminModulesHealthcareHospitalProfileRoute: typeof AdminModulesHealthcareHospitalProfileRoute
  AdminModulesHealthcareMedicalStaffRoute: typeof AdminModulesHealthcareMedicalStaffRoute
  AdminModulesGruhUdhyogInventoryRoute: typeof AdminModulesGruhUdhyogInventoryRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/donate": {
      id: "/donate"
      path: "/donate"
      fullPath: "/donate"
      preLoaderRoute: typeof DonateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/donate/": {
      id: "/donate/"
      path: "/"
      fullPath: "/donate/"
      preLoaderRoute: typeof DonateIndexRouteImport
      parentRoute: typeof DonateRouteRoute
    }
    "/admin/": {
      id: "/admin/"
      path: "/admin"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/": {
      id: "/_user/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof UserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/donate/scrap": {
      id: "/donate/scrap"
      path: "/scrap"
      fullPath: "/donate/scrap"
      preLoaderRoute: typeof DonateScrapRouteImport
      parentRoute: typeof DonateRouteRoute
    }
    "/donate/items": {
      id: "/donate/items"
      path: "/items"
      fullPath: "/donate/items"
      preLoaderRoute: typeof DonateItemsRouteImport
      parentRoute: typeof DonateRouteRoute
    }
    "/donate/inkind": {
      id: "/donate/inkind"
      path: "/inkind"
      fullPath: "/donate/inkind"
      preLoaderRoute: typeof DonateInkindRouteImport
      parentRoute: typeof DonateRouteRoute
    }
    "/donate/general": {
      id: "/donate/general"
      path: "/general"
      fullPath: "/donate/general"
      preLoaderRoute: typeof DonateGeneralRouteImport
      parentRoute: typeof DonateRouteRoute
    }
    "/_user/signup": {
      id: "/_user/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof UserSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/login": {
      id: "/_user/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof UserLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/csr-partnership": {
      id: "/_user/csr-partnership"
      path: "/csr-partnership"
      fullPath: "/csr-partnership"
      preLoaderRoute: typeof UserCsrPartnershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/contact": {
      id: "/_user/contact"
      path: "/contact"
      fullPath: "/contact"
      preLoaderRoute: typeof UserContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/account": {
      id: "/_user/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof UserAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/about": {
      id: "/_user/about"
      path: "/about"
      fullPath: "/about"
      preLoaderRoute: typeof UserAboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/donate/thank-you/$ref": {
      id: "/donate/thank-you/$ref"
      path: "/thank-you/$ref"
      fullPath: "/donate/thank-you/$ref"
      preLoaderRoute: typeof DonateThankYouRefRouteImport
      parentRoute: typeof DonateRouteRoute
    }
    "/admin/tiffin-seva/donations": {
      id: "/admin/tiffin-seva/donations"
      path: "/admin/tiffin-seva/donations"
      fullPath: "/admin/tiffin-seva/donations"
      preLoaderRoute: typeof AdminTiffinSevaDonationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/tiffin-seva/dashboard": {
      id: "/admin/tiffin-seva/dashboard"
      path: "/admin/tiffin-seva/dashboard"
      fullPath: "/admin/tiffin-seva/dashboard"
      preLoaderRoute: typeof AdminTiffinSevaDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/tiffin-seva/applications": {
      id: "/admin/tiffin-seva/applications"
      path: "/admin/tiffin-seva/applications"
      fullPath: "/admin/tiffin-seva/applications"
      preLoaderRoute: typeof AdminTiffinSevaApplicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_website/trustees": {
      id: "/admin/_website/trustees"
      path: "/admin/trustees"
      fullPath: "/admin/trustees"
      preLoaderRoute: typeof AdminWebsiteTrusteesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_website/posts": {
      id: "/admin/_website/posts"
      path: "/admin/posts"
      fullPath: "/admin/posts"
      preLoaderRoute: typeof AdminWebsitePostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_website/gallery": {
      id: "/admin/_website/gallery"
      path: "/admin/gallery"
      fullPath: "/admin/gallery"
      preLoaderRoute: typeof AdminWebsiteGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_user-roles/user-permissions": {
      id: "/admin/_user-roles/user-permissions"
      path: "/admin/user-permissions"
      fullPath: "/admin/user-permissions"
      preLoaderRoute: typeof AdminUserRolesUserPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_system/staff-roles": {
      id: "/admin/_system/staff-roles"
      path: "/admin/staff-roles"
      fullPath: "/admin/staff-roles"
      preLoaderRoute: typeof AdminSystemStaffRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_residents/visitors": {
      id: "/admin/_residents/visitors"
      path: "/admin/visitors"
      fullPath: "/admin/visitors"
      preLoaderRoute: typeof AdminResidentsVisitorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_residents/visitor-inquiry": {
      id: "/admin/_residents/visitor-inquiry"
      path: "/admin/visitor-inquiry"
      fullPath: "/admin/visitor-inquiry"
      preLoaderRoute: typeof AdminResidentsVisitorInquiryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_residents/residents": {
      id: "/admin/_residents/residents"
      path: "/admin/residents"
      fullPath: "/admin/residents"
      preLoaderRoute: typeof AdminResidentsResidentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_residents/resident-registration": {
      id: "/admin/_residents/resident-registration"
      path: "/admin/resident-registration"
      fullPath: "/admin/resident-registration"
      preLoaderRoute: typeof AdminResidentsResidentRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_residents/resident-family": {
      id: "/admin/_residents/resident-family"
      path: "/admin/resident-family"
      fullPath: "/admin/resident-family"
      preLoaderRoute: typeof AdminResidentsResidentFamilyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_residents/resident-death": {
      id: "/admin/_residents/resident-death"
      path: "/admin/resident-death"
      fullPath: "/admin/resident-death"
      preLoaderRoute: typeof AdminResidentsResidentDeathRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_residents/adoption": {
      id: "/admin/_residents/adoption"
      path: "/admin/adoption"
      fullPath: "/admin/adoption"
      preLoaderRoute: typeof AdminResidentsAdoptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_overview/reports": {
      id: "/admin/_overview/reports"
      path: "/admin/reports"
      fullPath: "/admin/reports"
      preLoaderRoute: typeof AdminOverviewReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_overview/dashboard": {
      id: "/admin/_overview/dashboard"
      path: "/admin/dashboard"
      fullPath: "/admin/dashboard"
      preLoaderRoute: typeof AdminOverviewDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_overview/ai-studio": {
      id: "/admin/_overview/ai-studio"
      path: "/admin/ai-studio"
      fullPath: "/admin/ai-studio"
      preLoaderRoute: typeof AdminOverviewAiStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/inventory": {
      id: "/admin/_modules/inventory"
      path: "/admin/inventory"
      fullPath: "/admin/inventory"
      preLoaderRoute: typeof AdminModulesInventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/hr-payroll": {
      id: "/admin/_modules/hr-payroll"
      path: "/admin/hr-payroll"
      fullPath: "/admin/hr-payroll"
      preLoaderRoute: typeof AdminModulesHrPayrollRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/event-categories": {
      id: "/admin/_modules/event-categories"
      path: "/admin/event-categories"
      fullPath: "/admin/event-categories"
      preLoaderRoute: typeof AdminModulesEventCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/community-events": {
      id: "/admin/_modules/community-events"
      path: "/admin/community-events"
      fullPath: "/admin/community-events"
      preLoaderRoute: typeof AdminModulesCommunityEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/communication": {
      id: "/admin/_modules/communication"
      path: "/admin/communication"
      fullPath: "/admin/communication"
      preLoaderRoute: typeof AdminModulesCommunicationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_manual-receipt/manual-receipts": {
      id: "/admin/_manual-receipt/manual-receipts"
      path: "/admin/manual-receipts"
      fullPath: "/admin/manual-receipts"
      preLoaderRoute: typeof AdminManualReceiptManualReceiptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_list-master/treatment-master": {
      id: "/admin/_list-master/treatment-master"
      path: "/admin/treatment-master"
      fullPath: "/admin/treatment-master"
      preLoaderRoute: typeof AdminListMasterTreatmentMasterRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_list-master/relationships": {
      id: "/admin/_list-master/relationships"
      path: "/admin/relationships"
      fullPath: "/admin/relationships"
      preLoaderRoute: typeof AdminListMasterRelationshipsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_list-master/jain-panchang": {
      id: "/admin/_list-master/jain-panchang"
      path: "/admin/jain-panchang"
      fullPath: "/admin/jain-panchang"
      preLoaderRoute: typeof AdminListMasterJainPanchangRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_list-master/festivals": {
      id: "/admin/_list-master/festivals"
      path: "/admin/festivals"
      fullPath: "/admin/festivals"
      preLoaderRoute: typeof AdminListMasterFestivalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_list-master/districts": {
      id: "/admin/_list-master/districts"
      path: "/admin/districts"
      fullPath: "/admin/districts"
      preLoaderRoute: typeof AdminListMasterDistrictsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_list-master/cities": {
      id: "/admin/_list-master/cities"
      path: "/admin/cities"
      fullPath: "/admin/cities"
      preLoaderRoute: typeof AdminListMasterCitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_list-master/areas": {
      id: "/admin/_list-master/areas"
      path: "/admin/areas"
      fullPath: "/admin/areas"
      preLoaderRoute: typeof AdminListMasterAreasRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_gaushala/vrindavan-gaushala": {
      id: "/admin/_gaushala/vrindavan-gaushala"
      path: "/admin/vrindavan-gaushala"
      fullPath: "/admin/vrindavan-gaushala"
      preLoaderRoute: typeof AdminGaushalaVrindavanGaushalaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_gaushala/gaushala-schemes": {
      id: "/admin/_gaushala/gaushala-schemes"
      path: "/admin/gaushala-schemes"
      fullPath: "/admin/gaushala-schemes"
      preLoaderRoute: typeof AdminGaushalaGaushalaSchemesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_gaushala/gaushala-donations": {
      id: "/admin/_gaushala/gaushala-donations"
      path: "/admin/gaushala-donations"
      fullPath: "/admin/gaushala-donations"
      preLoaderRoute: typeof AdminGaushalaGaushalaDonationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_engagement/tiffin": {
      id: "/admin/_engagement/tiffin"
      path: "/admin/tiffin"
      fullPath: "/admin/tiffin"
      preLoaderRoute: typeof AdminEngagementTiffinRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_engagement/punya-tithi": {
      id: "/admin/_engagement/punya-tithi"
      path: "/admin/punya-tithi"
      fullPath: "/admin/punya-tithi"
      preLoaderRoute: typeof AdminEngagementPunyaTithiRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_engagement/inquiries": {
      id: "/admin/_engagement/inquiries"
      path: "/admin/inquiries"
      fullPath: "/admin/inquiries"
      preLoaderRoute: typeof AdminEngagementInquiriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_engagement/feedback": {
      id: "/admin/_engagement/feedback"
      path: "/admin/feedback"
      fullPath: "/admin/feedback"
      preLoaderRoute: typeof AdminEngagementFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_engagement/csr-inquiries": {
      id: "/admin/_engagement/csr-inquiries"
      path: "/admin/csr-inquiries"
      fullPath: "/admin/csr-inquiries"
      preLoaderRoute: typeof AdminEngagementCsrInquiriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donations/scrap-donations": {
      id: "/admin/_donations/scrap-donations"
      path: "/admin/scrap-donations"
      fullPath: "/admin/scrap-donations"
      preLoaderRoute: typeof AdminDonationsScrapDonationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donations/recurring": {
      id: "/admin/_donations/recurring"
      path: "/admin/recurring"
      fullPath: "/admin/recurring"
      preLoaderRoute: typeof AdminDonationsRecurringRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donations/receipts": {
      id: "/admin/_donations/receipts"
      path: "/admin/receipts"
      fullPath: "/admin/receipts"
      preLoaderRoute: typeof AdminDonationsReceiptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donations/medical": {
      id: "/admin/_donations/medical"
      path: "/admin/medical"
      fullPath: "/admin/medical"
      preLoaderRoute: typeof AdminDonationsMedicalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donations/donors": {
      id: "/admin/_donations/donors"
      path: "/admin/donors"
      fullPath: "/admin/donors"
      preLoaderRoute: typeof AdminDonationsDonorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donations/donations": {
      id: "/admin/_donations/donations"
      path: "/admin/donations"
      fullPath: "/admin/donations"
      preLoaderRoute: typeof AdminDonationsDonationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/seva": {
      id: "/admin/_donation-setup/seva"
      path: "/admin/seva"
      fullPath: "/admin/seva"
      preLoaderRoute: typeof AdminDonationSetupSevaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/payment-settings": {
      id: "/admin/_donation-setup/payment-settings"
      path: "/admin/payment-settings"
      fullPath: "/admin/payment-settings"
      preLoaderRoute: typeof AdminDonationSetupPaymentSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/item-categories": {
      id: "/admin/_donation-setup/item-categories"
      path: "/admin/item-categories"
      fullPath: "/admin/item-categories"
      preLoaderRoute: typeof AdminDonationSetupItemCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/inkind": {
      id: "/admin/_donation-setup/inkind"
      path: "/admin/inkind"
      fullPath: "/admin/inkind"
      preLoaderRoute: typeof AdminDonationSetupInkindRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/infrastructure": {
      id: "/admin/_donation-setup/infrastructure"
      path: "/admin/infrastructure"
      fullPath: "/admin/infrastructure"
      preLoaderRoute: typeof AdminDonationSetupInfrastructureRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/events": {
      id: "/admin/_donation-setup/events"
      path: "/admin/events"
      fullPath: "/admin/events"
      preLoaderRoute: typeof AdminDonationSetupEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/donation-masters": {
      id: "/admin/_donation-setup/donation-masters"
      path: "/admin/donation-masters"
      fullPath: "/admin/donation-masters"
      preLoaderRoute: typeof AdminDonationSetupDonationMastersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_donation-setup/campaigns": {
      id: "/admin/_donation-setup/campaigns"
      path: "/admin/campaigns"
      fullPath: "/admin/campaigns"
      preLoaderRoute: typeof AdminDonationSetupCampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_bhojanshala/bhojan-schemes": {
      id: "/admin/_bhojanshala/bhojan-schemes"
      path: "/admin/bhojan-schemes"
      fullPath: "/admin/bhojan-schemes"
      preLoaderRoute: typeof AdminBhojanshalaBhojanSchemesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_bhojanshala/bhojan-packages": {
      id: "/admin/_bhojanshala/bhojan-packages"
      path: "/admin/bhojan-packages"
      fullPath: "/admin/bhojan-packages"
      preLoaderRoute: typeof AdminBhojanshalaBhojanPackagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_bhojanshala/bhojan-donations": {
      id: "/admin/_bhojanshala/bhojan-donations"
      path: "/admin/bhojan-donations"
      fullPath: "/admin/bhojan-donations"
      preLoaderRoute: typeof AdminBhojanshalaBhojanDonationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_bhojanshala/bhojan-categories": {
      id: "/admin/_bhojanshala/bhojan-categories"
      path: "/admin/bhojan-categories"
      fullPath: "/admin/bhojan-categories"
      preLoaderRoute: typeof AdminBhojanshalaBhojanCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_admissions/family-details": {
      id: "/admin/_admissions/family-details"
      path: "/admin/family-details"
      fullPath: "/admin/family-details"
      preLoaderRoute: typeof AdminAdmissionsFamilyDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_admissions/elder-registration": {
      id: "/admin/_admissions/elder-registration"
      path: "/admin/elder-registration"
      fullPath: "/admin/elder-registration"
      preLoaderRoute: typeof AdminAdmissionsElderRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_admissions/admission-recommendation": {
      id: "/admin/_admissions/admission-recommendation"
      path: "/admin/admission-recommendation"
      fullPath: "/admin/admission-recommendation"
      preLoaderRoute: typeof AdminAdmissionsAdmissionRecommendationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_admissions/admission-inquiry": {
      id: "/admin/_admissions/admission-inquiry"
      path: "/admin/admission-inquiry"
      fullPath: "/admin/admission-inquiry"
      preLoaderRoute: typeof AdminAdmissionsAdmissionInquiryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_admissions/admission-approval": {
      id: "/admin/_admissions/admission-approval"
      path: "/admin/admission-approval"
      fullPath: "/admin/admission-approval"
      preLoaderRoute: typeof AdminAdmissionsAdmissionApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_admissions/admission-applications": {
      id: "/admin/_admissions/admission-applications"
      path: "/admin/admission-applications"
      fullPath: "/admin/admission-applications"
      preLoaderRoute: typeof AdminAdmissionsAdmissionApplicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_trust/trustees": {
      id: "/_user/_trust/trustees"
      path: "/trustees"
      fullPath: "/trustees"
      preLoaderRoute: typeof UserTrustTrusteesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_trust/transparency": {
      id: "/_user/_trust/transparency"
      path: "/transparency"
      fullPath: "/transparency"
      preLoaderRoute: typeof UserTrustTransparencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_programs/tiffin-seva": {
      id: "/_user/_programs/tiffin-seva"
      path: "/tiffin-seva"
      fullPath: "/tiffin-seva"
      preLoaderRoute: typeof UserProgramsTiffinSevaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_programs/gruh-udhyog": {
      id: "/_user/_programs/gruh-udhyog"
      path: "/gruh-udhyog"
      fullPath: "/gruh-udhyog"
      preLoaderRoute: typeof UserProgramsGruhUdhyogRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_programs/gaushala": {
      id: "/_user/_programs/gaushala"
      path: "/gaushala"
      fullPath: "/gaushala"
      preLoaderRoute: typeof UserProgramsGaushalaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_programs/bhojanshala": {
      id: "/_user/_programs/bhojanshala"
      path: "/bhojanshala"
      fullPath: "/bhojanshala"
      preLoaderRoute: typeof UserProgramsBhojanshalaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_community/visitor-inquiry": {
      id: "/_user/_community/visitor-inquiry"
      path: "/visitor-inquiry"
      fullPath: "/visitor-inquiry"
      preLoaderRoute: typeof UserCommunityVisitorInquiryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_community/visitor-form": {
      id: "/_user/_community/visitor-form"
      path: "/visitor-form"
      fullPath: "/visitor-form"
      preLoaderRoute: typeof UserCommunityVisitorFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_community/news": {
      id: "/_user/_community/news"
      path: "/news"
      fullPath: "/news"
      preLoaderRoute: typeof UserCommunityNewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_community/jain-panchang": {
      id: "/_user/_community/jain-panchang"
      path: "/jain-panchang"
      fullPath: "/jain-panchang"
      preLoaderRoute: typeof UserCommunityJainPanchangRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_community/gallery": {
      id: "/_user/_community/gallery"
      path: "/gallery"
      fullPath: "/gallery"
      preLoaderRoute: typeof UserCommunityGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_community/feedback": {
      id: "/_user/_community/feedback"
      path: "/feedback"
      fullPath: "/feedback"
      preLoaderRoute: typeof UserCommunityFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_community/events": {
      id: "/_user/_community/events"
      path: "/events"
      fullPath: "/events"
      preLoaderRoute: typeof UserCommunityEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_care/resident-care": {
      id: "/_user/_care/resident-care"
      path: "/resident-care"
      fullPath: "/resident-care"
      preLoaderRoute: typeof UserCareResidentCareRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_care/healthcare": {
      id: "/_user/_care/healthcare"
      path: "/healthcare"
      fullPath: "/healthcare"
      preLoaderRoute: typeof UserCareHealthcareRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_care/elder-care-program": {
      id: "/_user/_care/elder-care-program"
      path: "/elder-care-program"
      fullPath: "/elder-care-program"
      preLoaderRoute: typeof UserCareElderCareProgramRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_admission/apply-admission": {
      id: "/_user/_admission/apply-admission"
      path: "/apply-admission"
      fullPath: "/apply-admission"
      preLoaderRoute: typeof UserAdmissionApplyAdmissionRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_admission/admission-inquiry": {
      id: "/_user/_admission/admission-inquiry"
      path: "/admission-inquiry"
      fullPath: "/admission-inquiry"
      preLoaderRoute: typeof UserAdmissionAdmissionInquiryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_user/_care/healthcare/": {
      id: "/_user/_care/healthcare/"
      path: "/"
      fullPath: "/healthcare/"
      preLoaderRoute: typeof UserCareHealthcareIndexRouteImport
      parentRoute: typeof UserCareHealthcareRoute
    }
    "/donate/c/$kind/$id": {
      id: "/donate/c/$kind/$id"
      path: "/c/$kind/$id"
      fullPath: "/donate/c/$kind/$id"
      preLoaderRoute: typeof DonateCKindIdRouteImport
      parentRoute: typeof DonateRouteRoute
    }
    "/admin/_modules/_healthcare/medical-staff": {
      id: "/admin/_modules/_healthcare/medical-staff"
      path: "/admin/medical-staff"
      fullPath: "/admin/medical-staff"
      preLoaderRoute: typeof AdminModulesHealthcareMedicalStaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_healthcare/hospital-profile": {
      id: "/admin/_modules/_healthcare/hospital-profile"
      path: "/admin/hospital-profile"
      fullPath: "/admin/hospital-profile"
      preLoaderRoute: typeof AdminModulesHealthcareHospitalProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_healthcare/healthcare-management": {
      id: "/admin/_modules/_healthcare/healthcare-management"
      path: "/admin/healthcare-management"
      fullPath: "/admin/healthcare-management"
      preLoaderRoute: typeof AdminModulesHealthcareHealthcareManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_healthcare/healthcare-donations": {
      id: "/admin/_modules/_healthcare/healthcare-donations"
      path: "/admin/healthcare-donations"
      fullPath: "/admin/healthcare-donations"
      preLoaderRoute: typeof AdminModulesHealthcareHealthcareDonationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_healthcare/healthcare": {
      id: "/admin/_modules/_healthcare/healthcare"
      path: "/admin/healthcare"
      fullPath: "/admin/healthcare"
      preLoaderRoute: typeof AdminModulesHealthcareHealthcareRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/stock-entries": {
      id: "/admin/_modules/_gruh-udhyog/stock-entries"
      path: "/admin/stock-entries"
      fullPath: "/admin/stock-entries"
      preLoaderRoute: typeof AdminModulesGruhUdhyogStockEntriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/products": {
      id: "/admin/_modules/_gruh-udhyog/products"
      path: "/admin/products"
      fullPath: "/admin/products"
      preLoaderRoute: typeof AdminModulesGruhUdhyogProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/product-variants": {
      id: "/admin/_modules/_gruh-udhyog/product-variants"
      path: "/admin/product-variants"
      fullPath: "/admin/product-variants"
      preLoaderRoute: typeof AdminModulesGruhUdhyogProductVariantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/product-orders": {
      id: "/admin/_modules/_gruh-udhyog/product-orders"
      path: "/admin/product-orders"
      fullPath: "/admin/product-orders"
      preLoaderRoute: typeof AdminModulesGruhUdhyogProductOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/product-categories": {
      id: "/admin/_modules/_gruh-udhyog/product-categories"
      path: "/admin/product-categories"
      fullPath: "/admin/product-categories"
      preLoaderRoute: typeof AdminModulesGruhUdhyogProductCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/gruh-udhyog-inventory": {
      id: "/admin/_modules/_gruh-udhyog/gruh-udhyog-inventory"
      path: "/admin/gruh-udhyog-inventory"
      fullPath: "/admin/gruh-udhyog-inventory"
      preLoaderRoute: typeof AdminModulesGruhUdhyogGruhUdhyogInventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/gruh-udhyog": {
      id: "/admin/_modules/_gruh-udhyog/gruh-udhyog"
      path: "/admin/gruh-udhyog"
      fullPath: "/admin/gruh-udhyog"
      preLoaderRoute: typeof AdminModulesGruhUdhyogGruhUdhyogRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gruh-udhyog/franchise-enquiries": {
      id: "/admin/_modules/_gruh-udhyog/franchise-enquiries"
      path: "/admin/franchise-enquiries"
      fullPath: "/admin/franchise-enquiries"
      preLoaderRoute: typeof AdminModulesGruhUdhyogFranchiseEnquiriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gaushala/gaushala": {
      id: "/admin/_modules/_gaushala/gaushala"
      path: "/admin/gaushala"
      fullPath: "/admin/gaushala"
      preLoaderRoute: typeof AdminModulesGaushalaGaushalaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_gaushala/animals": {
      id: "/admin/_modules/_gaushala/animals"
      path: "/admin/animals"
      fullPath: "/admin/animals"
      preLoaderRoute: typeof AdminModulesGaushalaAnimalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_elder-care/residents": {
      id: "/admin/_modules/_elder-care/residents"
      path: "/admin/residents"
      fullPath: "/admin/residents"
      preLoaderRoute: typeof AdminModulesElderCareResidentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_modules/_elder-care/elder-care": {
      id: "/admin/_modules/_elder-care/elder-care"
      path: "/admin/elder-care"
      fullPath: "/admin/elder-care"
      preLoaderRoute: typeof AdminModulesElderCareElderCareRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/_admissions/admission-applications/$id": {
      id: "/admin/_admissions/admission-applications/$id"
      path: "/$id"
      fullPath: "/admin/admission-applications/$id"
      preLoaderRoute: typeof AdminAdmissionsAdmissionApplicationsIdRouteImport
      parentRoute: typeof AdminAdmissionsAdmissionApplicationsRoute
    }
    "/_user/_care/healthcare/$id": {
      id: "/_user/_care/healthcare/$id"
      path: "/$id"
      fullPath: "/healthcare/$id"
      preLoaderRoute: typeof UserCareHealthcareIdRouteImport
      parentRoute: typeof UserCareHealthcareRoute
    }
    "/admin/_modules/_elder-care/residents/$id": {
      id: "/admin/_modules/_elder-care/residents/$id"
      path: "/$id"
      fullPath: "/admin/residents/$id"
      preLoaderRoute: typeof AdminModulesElderCareResidentsIdRouteImport
      parentRoute: typeof AdminModulesElderCareResidentsRoute
    }
    "/admin/_modules/_gruh-udhyog/inventory/": {
      id: "/admin/_modules/_gruh-udhyog/inventory/"
      path: "/admin/inventory"
      fullPath: "/admin/inventory/"
      preLoaderRoute: typeof AdminModulesGruhUdhyogInventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface DonateRouteRouteChildren {
  DonateGeneralRoute: typeof DonateGeneralRoute
  DonateInkindRoute: typeof DonateInkindRoute
  DonateItemsRoute: typeof DonateItemsRoute
  DonateScrapRoute: typeof DonateScrapRoute
  DonateIndexRoute: typeof DonateIndexRoute
  DonateThankYouRefRoute: typeof DonateThankYouRefRoute
  DonateCKindIdRoute: typeof DonateCKindIdRoute
}

const DonateRouteRouteChildren: DonateRouteRouteChildren = {
  DonateGeneralRoute: DonateGeneralRoute,
  DonateInkindRoute: DonateInkindRoute,
  DonateItemsRoute: DonateItemsRoute,
  DonateScrapRoute: DonateScrapRoute,
  DonateIndexRoute: DonateIndexRoute,
  DonateThankYouRefRoute: DonateThankYouRefRoute,
  DonateCKindIdRoute: DonateCKindIdRoute,
}

const DonateRouteRouteWithChildren = DonateRouteRoute._addFileChildren(
  DonateRouteRouteChildren,
)

interface UserCareHealthcareRouteChildren {
  UserCareHealthcareIdRoute: typeof UserCareHealthcareIdRoute
  UserCareHealthcareIndexRoute: typeof UserCareHealthcareIndexRoute
}

const UserCareHealthcareRouteChildren: UserCareHealthcareRouteChildren = {
  UserCareHealthcareIdRoute: UserCareHealthcareIdRoute,
  UserCareHealthcareIndexRoute: UserCareHealthcareIndexRoute,
}

const UserCareHealthcareRouteWithChildren =
  UserCareHealthcareRoute._addFileChildren(UserCareHealthcareRouteChildren)

interface AdminAdmissionsAdmissionApplicationsRouteChildren {
  AdminAdmissionsAdmissionApplicationsIdRoute: typeof AdminAdmissionsAdmissionApplicationsIdRoute
}

const AdminAdmissionsAdmissionApplicationsRouteChildren: AdminAdmissionsAdmissionApplicationsRouteChildren =
  {
    AdminAdmissionsAdmissionApplicationsIdRoute:
      AdminAdmissionsAdmissionApplicationsIdRoute,
  }

const AdminAdmissionsAdmissionApplicationsRouteWithChildren =
  AdminAdmissionsAdmissionApplicationsRoute._addFileChildren(
    AdminAdmissionsAdmissionApplicationsRouteChildren,
  )

interface AdminModulesElderCareResidentsRouteChildren {
  AdminModulesElderCareResidentsIdRoute: typeof AdminModulesElderCareResidentsIdRoute
}

const AdminModulesElderCareResidentsRouteChildren: AdminModulesElderCareResidentsRouteChildren =
  {
    AdminModulesElderCareResidentsIdRoute:
      AdminModulesElderCareResidentsIdRoute,
  }

const AdminModulesElderCareResidentsRouteWithChildren =
  AdminModulesElderCareResidentsRoute._addFileChildren(
    AdminModulesElderCareResidentsRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  DonateRouteRoute: DonateRouteRouteWithChildren,
  UserAboutRoute: UserAboutRoute,
  UserAccountRoute: UserAccountRoute,
  UserContactRoute: UserContactRoute,
  UserCsrPartnershipRoute: UserCsrPartnershipRoute,
  UserLoginRoute: UserLoginRoute,
  UserSignupRoute: UserSignupRoute,
  UserIndexRoute: UserIndexRoute,
  AdminIndexRoute: AdminIndexRoute,
  UserAdmissionAdmissionInquiryRoute: UserAdmissionAdmissionInquiryRoute,
  UserAdmissionApplyAdmissionRoute: UserAdmissionApplyAdmissionRoute,
  UserCareElderCareProgramRoute: UserCareElderCareProgramRoute,
  UserCareHealthcareRoute: UserCareHealthcareRouteWithChildren,
  UserCareResidentCareRoute: UserCareResidentCareRoute,
  UserCommunityEventsRoute: UserCommunityEventsRoute,
  UserCommunityFeedbackRoute: UserCommunityFeedbackRoute,
  UserCommunityGalleryRoute: UserCommunityGalleryRoute,
  UserCommunityJainPanchangRoute: UserCommunityJainPanchangRoute,
  UserCommunityNewsRoute: UserCommunityNewsRoute,
  UserCommunityVisitorFormRoute: UserCommunityVisitorFormRoute,
  UserCommunityVisitorInquiryRoute: UserCommunityVisitorInquiryRoute,
  UserProgramsBhojanshalaRoute: UserProgramsBhojanshalaRoute,
  UserProgramsGaushalaRoute: UserProgramsGaushalaRoute,
  UserProgramsGruhUdhyogRoute: UserProgramsGruhUdhyogRoute,
  UserProgramsTiffinSevaRoute: UserProgramsTiffinSevaRoute,
  UserTrustTransparencyRoute: UserTrustTransparencyRoute,
  UserTrustTrusteesRoute: UserTrustTrusteesRoute,
  AdminAdmissionsAdmissionApplicationsRoute:
    AdminAdmissionsAdmissionApplicationsRouteWithChildren,
  AdminAdmissionsAdmissionApprovalRoute: AdminAdmissionsAdmissionApprovalRoute,
  AdminAdmissionsAdmissionInquiryRoute: AdminAdmissionsAdmissionInquiryRoute,
  AdminAdmissionsAdmissionRecommendationRoute:
    AdminAdmissionsAdmissionRecommendationRoute,
  AdminAdmissionsElderRegistrationRoute: AdminAdmissionsElderRegistrationRoute,
  AdminAdmissionsFamilyDetailsRoute: AdminAdmissionsFamilyDetailsRoute,
  AdminBhojanshalaBhojanCategoriesRoute: AdminBhojanshalaBhojanCategoriesRoute,
  AdminBhojanshalaBhojanDonationsRoute: AdminBhojanshalaBhojanDonationsRoute,
  AdminBhojanshalaBhojanPackagesRoute: AdminBhojanshalaBhojanPackagesRoute,
  AdminBhojanshalaBhojanSchemesRoute: AdminBhojanshalaBhojanSchemesRoute,
  AdminDonationSetupCampaignsRoute: AdminDonationSetupCampaignsRoute,
  AdminDonationSetupDonationMastersRoute:
    AdminDonationSetupDonationMastersRoute,
  AdminDonationSetupEventsRoute: AdminDonationSetupEventsRoute,
  AdminDonationSetupInfrastructureRoute: AdminDonationSetupInfrastructureRoute,
  AdminDonationSetupInkindRoute: AdminDonationSetupInkindRoute,
  AdminDonationSetupItemCategoriesRoute: AdminDonationSetupItemCategoriesRoute,
  AdminDonationSetupPaymentSettingsRoute:
    AdminDonationSetupPaymentSettingsRoute,
  AdminDonationSetupSevaRoute: AdminDonationSetupSevaRoute,
  AdminDonationsDonationsRoute: AdminDonationsDonationsRoute,
  AdminDonationsDonorsRoute: AdminDonationsDonorsRoute,
  AdminDonationsMedicalRoute: AdminDonationsMedicalRoute,
  AdminDonationsReceiptsRoute: AdminDonationsReceiptsRoute,
  AdminDonationsRecurringRoute: AdminDonationsRecurringRoute,
  AdminDonationsScrapDonationsRoute: AdminDonationsScrapDonationsRoute,
  AdminEngagementCsrInquiriesRoute: AdminEngagementCsrInquiriesRoute,
  AdminEngagementFeedbackRoute: AdminEngagementFeedbackRoute,
  AdminEngagementInquiriesRoute: AdminEngagementInquiriesRoute,
  AdminEngagementPunyaTithiRoute: AdminEngagementPunyaTithiRoute,
  AdminEngagementTiffinRoute: AdminEngagementTiffinRoute,
  AdminGaushalaGaushalaDonationsRoute: AdminGaushalaGaushalaDonationsRoute,
  AdminGaushalaGaushalaSchemesRoute: AdminGaushalaGaushalaSchemesRoute,
  AdminGaushalaVrindavanGaushalaRoute: AdminGaushalaVrindavanGaushalaRoute,
  AdminListMasterAreasRoute: AdminListMasterAreasRoute,
  AdminListMasterCitiesRoute: AdminListMasterCitiesRoute,
  AdminListMasterDistrictsRoute: AdminListMasterDistrictsRoute,
  AdminListMasterFestivalsRoute: AdminListMasterFestivalsRoute,
  AdminListMasterJainPanchangRoute: AdminListMasterJainPanchangRoute,
  AdminListMasterRelationshipsRoute: AdminListMasterRelationshipsRoute,
  AdminListMasterTreatmentMasterRoute: AdminListMasterTreatmentMasterRoute,
  AdminManualReceiptManualReceiptsRoute: AdminManualReceiptManualReceiptsRoute,
  AdminModulesCommunicationRoute: AdminModulesCommunicationRoute,
  AdminModulesCommunityEventsRoute: AdminModulesCommunityEventsRoute,
  AdminModulesEventCategoriesRoute: AdminModulesEventCategoriesRoute,
  AdminModulesHrPayrollRoute: AdminModulesHrPayrollRoute,
  AdminModulesInventoryRoute: AdminModulesInventoryRoute,
  AdminOverviewAiStudioRoute: AdminOverviewAiStudioRoute,
  AdminOverviewDashboardRoute: AdminOverviewDashboardRoute,
  AdminOverviewReportsRoute: AdminOverviewReportsRoute,
  AdminResidentsAdoptionRoute: AdminResidentsAdoptionRoute,
  AdminResidentsResidentDeathRoute: AdminResidentsResidentDeathRoute,
  AdminResidentsResidentFamilyRoute: AdminResidentsResidentFamilyRoute,
  AdminResidentsResidentRegistrationRoute:
    AdminResidentsResidentRegistrationRoute,
  AdminResidentsResidentsRoute: AdminResidentsResidentsRoute,
  AdminResidentsVisitorInquiryRoute: AdminResidentsVisitorInquiryRoute,
  AdminResidentsVisitorsRoute: AdminResidentsVisitorsRoute,
  AdminSystemStaffRolesRoute: AdminSystemStaffRolesRoute,
  AdminUserRolesUserPermissionsRoute: AdminUserRolesUserPermissionsRoute,
  AdminWebsiteGalleryRoute: AdminWebsiteGalleryRoute,
  AdminWebsitePostsRoute: AdminWebsitePostsRoute,
  AdminWebsiteTrusteesRoute: AdminWebsiteTrusteesRoute,
  AdminTiffinSevaApplicationsRoute: AdminTiffinSevaApplicationsRoute,
  AdminTiffinSevaDashboardRoute: AdminTiffinSevaDashboardRoute,
  AdminTiffinSevaDonationsRoute: AdminTiffinSevaDonationsRoute,
  AdminModulesElderCareElderCareRoute: AdminModulesElderCareElderCareRoute,
  AdminModulesElderCareResidentsRoute:
    AdminModulesElderCareResidentsRouteWithChildren,
  AdminModulesGaushalaAnimalsRoute: AdminModulesGaushalaAnimalsRoute,
  AdminModulesGaushalaGaushalaRoute: AdminModulesGaushalaGaushalaRoute,
  AdminModulesGruhUdhyogFranchiseEnquiriesRoute:
    AdminModulesGruhUdhyogFranchiseEnquiriesRoute,
  AdminModulesGruhUdhyogGruhUdhyogRoute: AdminModulesGruhUdhyogGruhUdhyogRoute,
  AdminModulesGruhUdhyogGruhUdhyogInventoryRoute:
    AdminModulesGruhUdhyogGruhUdhyogInventoryRoute,
  AdminModulesGruhUdhyogProductCategoriesRoute:
    AdminModulesGruhUdhyogProductCategoriesRoute,
  AdminModulesGruhUdhyogProductOrdersRoute:
    AdminModulesGruhUdhyogProductOrdersRoute,
  AdminModulesGruhUdhyogProductVariantsRoute:
    AdminModulesGruhUdhyogProductVariantsRoute,
  AdminModulesGruhUdhyogProductsRoute: AdminModulesGruhUdhyogProductsRoute,
  AdminModulesGruhUdhyogStockEntriesRoute:
    AdminModulesGruhUdhyogStockEntriesRoute,
  AdminModulesHealthcareHealthcareRoute: AdminModulesHealthcareHealthcareRoute,
  AdminModulesHealthcareHealthcareDonationsRoute:
    AdminModulesHealthcareHealthcareDonationsRoute,
  AdminModulesHealthcareHealthcareManagementRoute:
    AdminModulesHealthcareHealthcareManagementRoute,
  AdminModulesHealthcareHospitalProfileRoute:
    AdminModulesHealthcareHospitalProfileRoute,
  AdminModulesHealthcareMedicalStaffRoute:
    AdminModulesHealthcareMedicalStaffRoute,
  AdminModulesGruhUdhyogInventoryRoute: AdminModulesGruhUdhyogInventoryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
